<template>
  <div class="icc__block">
    <div class="icc__block-body">
      <div
        class="icc__block-container icc__block-overflow mb-4"
        v-if="activeTab == 0"
      >
        <div class="icc__block-row">
          <div class="icc__block-text sticky sticky_top">
            <div class="icc__block-title">Продолжить сбор жалоб</div>
            <div class="icc__block-description">
              <b>Выберите, что следует узнать у пациентки</b>
            </div>
            <div class="icc__form">
              <RadioButton
                class="mt-6 mb-2"
                :inputValue="0"
                v-model="radioTabs[0]"
                :label="'Расскажите, как ощущаете дискомфорт и боль в груди?'"
              />
              <RadioButton
                class="mb-2"
                :inputValue="1"
                v-model="radioTabs[0]"
                :label="'Раньше подобный дискомфорт в груди беспокоил?'"
              />
              <RadioButton
                class="mb-2"
                :inputValue="2"
                v-model="radioTabs[0]"
                :label="'Беспокоит ли одышка и в каких ситуациях?'"
              />
              <RadioButton
                class="mb-2"
                :inputValue="3"
                v-model="radioTabs[0]"
                :label="'Что-то еще беспокоит?'"
              />
            </div>
          </div>
          <div class="icc__block-video">
            <img
              v-if="radioTabs[0] === null"
              :src="
                `https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/step2_video1.jpg`
              "
            />
            <div class="icc__video-tip mt-6" v-if="radioTabs[0] === null">
              <div class="icc__video-tip-icon">
                <img
                  :src="`
                    https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/question-icon.svg
                  `"
                />
              </div>
              <div class="icc__video-tip-text">
                <div class="icc__video-tip-title">Подсказка</div>
                <div class="icc__video-tip-description d-none d-xl-block">
                  Выберите вариант на панели слева, чтобы услышать пациента
                </div>
                <div class="icc__video-tip-description d-xl-none">
                  Выберите вариант на панели выше, чтобы услышать пациента
                </div>
              </div>
            </div>
            <video
              v-if="radioTabs[0] === 0"
              :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/interactive-clinical-case/pacient/2.mp4`"
              :poster="
                `https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/step1_video1.jpg`
              "
              controls
            />
            <div v-if="radioTabs[0] === 0" class="text-1 mt-2">
              Дискомфорт возникает после появления частого неритмичного
              сердцебиения, на фоне стресса, либо при повышении артериального
              давления до 135/80 мм рт.ст., беспокоит в левой половине грудной
              клетки, без иррадиации, он колющий, продолжительностью более 10
              минут, имеет волнообразный характер.
            </div>
            <video
              v-if="radioTabs[0] === 1"
              :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/interactive-clinical-case/pacient/3.mp4`"
              :poster="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/step1_video1.jpg
              `"
              controls
            />
            <div v-if="radioTabs[0] === 1" class="text-1 mt-2">
              Дискомфорт беспокоит последние 3 года. Ранее похожий дискомфорт
              внезапно возникал после стресса, физической нагрузки, последнее
              время беспокоит чаще и более интенсивно. Исчезал этот дискомфорт
              после того, как успокаивалась эмоционально или проходило
              сердцебиение. Обычно продолжительность была не более 20–30 минут.
            </div>
            <video
              v-if="radioTabs[0] === 2"
              :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/interactive-clinical-case/pacient/4.mp4`"
              :poster="
                `https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/step1_video1.jpg`
              "
              controls
            />
            <div v-if="radioTabs[0] === 2" class="text-1 mt-2">
              Одышка беспокоит при подъеме на 4 этаж на протяжении около года,
              хотя ранее не отмечала (живет на 5 этаже без лифта). Стала
              избегать физической нагрузки.
            </div>
            <video
              v-if="radioTabs[0] === 3"
              :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/interactive-clinical-case/pacient/5.mp4`"
              :poster="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/step1_video1.jpg
              `"
              controls
            />
            <div v-if="radioTabs[0] === 3" class="text-1 mt-2">
              Последние полгода стала эпизодически отмечать (до 2 раз в месяц)
              нарушения сна по типу трудностей засыпания перед субъективно
              значимыми событиями, "прокручивает негативные сценарии в голове",
              при этом есть дневная сонливость, влияет на работоспособность.
            </div>
          </div>
        </div>
      </div>
      <div
        class="icc__block-container icc__block-overflow mb-4"
        v-if="activeTab == 1"
      >
        <div class="icc__block-row">
          <div class="icc__block-text sticky sticky_top">
            <div class="icc__block-title">Уточнить анамнез заболевания</div>
            <div class="icc__block-description">
              <b>Выберите, что следует узнать у пациентки</b>
            </div>
            <div class="icc__form">
              <RadioButton
                class="mt-6 mb-2"
                :inputValue="0"
                v-model="radioTabs[1]"
                :label="'Как давно Вам известно о повышении АД и аритмии?'"
              />
              <RadioButton
                class="mb-2"
                :inputValue="1"
                v-model="radioTabs[1]"
                :label="'Отмели ли Вы ухудшение Вашего самочувствия за последний год?'"
              />
              <RadioButton
                class="mb-2"
                :inputValue="2"
                v-model="radioTabs[1]"
                :label="'Нарушения ритма начинается внезапно?'"
              />
              <RadioButton
                class="mb-2"
                :inputValue="3"
                v-model="radioTabs[1]"
                :label="'В момент аритмии беспокоит что-либо еще?'"
              />
            </div>
          </div>
          <div class="icc__block-video">
            <img
              v-if="radioTabs[1] === null"
              :src="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/step2_video1.jpg
              `"
            />
            <div class="icc__video-tip mt-6" v-if="radioTabs[1] === null">
              <div class="icc__video-tip-icon">
                <img
                  :src="`
                    https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/question-icon.svg
                  `"
                />
              </div>
              <div class="icc__video-tip-text">
                <div class="icc__video-tip-title">Подсказка</div>
                <div class="icc__video-tip-description d-none d-xl-block">
                  Выберите вариант на панели слева, чтобы услышать пациента
                </div>
                <div class="icc__video-tip-description d-xl-none">
                  Выберите вариант на панели выше, чтобы услышать пациента
                </div>
              </div>
            </div>
            <video
              v-if="radioTabs[1] === 0"
              :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/interactive-clinical-case/pacient/6.mp4`"
              :poster="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/step1_video1.jpg
              `"
              controls
            />
            <div v-if="radioTabs[1] === 0" class="text-1 mt-2">
              Проходила в течение жизни диспансеризацию. Около 3 лет назад по
              назначению врача поликлиники (планово) выполняла УЗИ сердца,
              суточный мониторинг артериального давления и ЭКГ, когда были
              жалобы на учащенное сердцебиение и эпизоды повышения АД до 180/100
              мм рт. ст., рекомендовано лечение периндоприл 5 мг, индапамид 1,5
              мг. После подбора лечения к кардиологу не обращалась, не
              обследовалась, сдавала анализы только по диспансеризации на
              работе, результаты не забирала. На фоне терапии АД не повышалось
              выше 135/80 мм рт.ст., однако перебои в работе сердца сохранялись,
              особенно на фоне психоэмоционального стресса. При перебоях в
              сердце принимала успокаивающие капельки (калия и магния), по
              совету подруги, помогало, сразу успокаивалась.
            </div>
            <video
              v-if="radioTabs[1] === 1"
              :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/interactive-clinical-case/pacient/7.mp4`"
              :poster="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/step1_video1.jpg
              `"
              controls
            />
            <div v-if="radioTabs[1] === 1" class="text-1 mt-2">
              С осени 2023 года перебои в сердце стали возникать чаще после
              смерти домашнего питомца. В апреле 2024 года утром проснулась от
              ощущения нехватки воздуха, частого аритмичного сердцебиения, в
              связи с чем вызвала скорую и была госпитализирована в стационар с
              впервые выявленным пароксизмом фибрилляции предсердий. В
              стационаре обследована, результаты взяла с собой (будут
              представлены далее). Аритмию купировали с помощью в/в капельного
              вливания, назначили терапию, однако после выписки из больницы не
              стала принимать часть рекомендованного лечения, отказалась от
              приема статинов, заменила на препараты омега-3 жирных кислот.
              Эпизодически при приступах нарушения сердцебиения принимает
              пропранолол 20 мг, если в течение 10-15 мин не замечает эффекта,
              принимает дополнительно 20 мг (не более 40 мг); отмечает эффект на
              снижение артериального давления. Около 3 дней назад на фоне
              стресса стала замечать перебои в работе сердца, самостоятельно
              прошла суточный мониторинг ЭКГ, обратилась к терапевту,
              рекомендована консультация кардиолога. Строит планы поехать на
              дачу.
            </div>
            <video
              v-if="radioTabs[1] === 2"
              :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/interactive-clinical-case/pacient/8.mp4`"
              :poster="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/step1_video1.jpg
              `"
              controls
            />
            <div v-if="radioTabs[1] === 2" class="text-1 mt-2">
              Обычно внезапно, на фоне стресса, ощущает, что сердце часто
              бьется, но ритмично, а потом резко, внезапно начинает
              «кувыркаться» в груди, «бьется то чаще, то замедляется»,
              испытывает страх потери сознания, страх смерти. В покое в течение
              10-15 минут отмечает постепенное улучшение состояние,
              «восстановление ритма».
            </div>
            <video
              v-if="radioTabs[1] === 3"
              :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/interactive-clinical-case/pacient/9.mp4`"
              :poster="
                `https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/step1_video1.jpg`
              "
              controls
            />
            <div v-if="radioTabs[1] === 3" class="text-1 mt-2">
              В момент, когда начинается неритмичное сердцебиение у меня на пару
              секунд возникает чувство нехватки воздуха и сдавления,
              заложенности в груди, но потом проходит. Затем появляется
              дискомфорт в левой половине грудной клетки, о котором говорила
              ранее. Иногда усиливается потоотделение.
            </div>
          </div>
        </div>
      </div>
      <div
        class="icc__block-container icc__block-overflow mb-4"
        v-if="activeTab == 2"
      >
        <div class="icc__block-row">
          <div class="icc__block-text sticky sticky_top">
            <div class="icc__block-title">Уточнить анамнез заболевания</div>
            <div class="icc__block-description">
              <b>Выберите, что следует узнать у пациентки</b>
            </div>
            <div class="icc__form">
              <RadioButton
                class="mt-6 mb-2"
                :inputValue="0"
                v-model="radioTabs[2]"
                :label="'Хронические заболевания'"
              />
              <RadioButton
                class="mb-2"
                :inputValue="1"
                v-model="radioTabs[2]"
                :label="'Лекарственный и аллергический анамнез'"
              />
              <RadioButton
                class="mb-2"
                :inputValue="2"
                v-model="radioTabs[2]"
                :label="'Наследственность'"
              />
              <RadioButton
                class="mb-2"
                :inputValue="3"
                v-model="radioTabs[2]"
                :label="'Гинекологический анамнез'"
              />
              <RadioButton
                class="mb-2"
                :inputValue="4"
                v-model="radioTabs[2]"
                :label="'Образ жизни'"
              />
            </div>
          </div>
          <div class="icc__block-video">
            <img
              v-if="radioTabs[2] === null"
              :src="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/step2_video1.jpg
              `"
            />
            <div class="icc__video-tip mt-6" v-if="radioTabs[2] === null">
              <div class="icc__video-tip-icon">
                <img
                  :src="`
                    https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/question-icon.svg
                  `"
                />
              </div>
              <div class="icc__video-tip-text">
                <div class="icc__video-tip-title">Подсказка</div>
                <div class="icc__video-tip-description d-none d-xl-block">
                  Выберите вариант на панели слева, чтобы услышать пациента
                </div>
                <div class="icc__video-tip-description d-xl-none">
                  Выберите вариант на панели выше, чтобы услышать пациента
                </div>
              </div>
            </div>
            <video
              v-if="radioTabs[2] === 0"
              :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/interactive-clinical-case/pacient/10.mp4`"
              :poster="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/step1_video1.jpg
              `"
              controls
            />
            <div v-if="radioTabs[2] === 0" class="text-1 mt-2">
              Повышение артериального давления беспокоит с 40 лет, в прошлом
              были повышения АД до 180/100 мм рт.ст.,в настоящее время на фоне
              приема антигипертензивной терапии АД 120-130/70-80 мм рт.ст. Около
              5 лет назад выявили хроническую болезнь почек, в дальнейшем
              специализированно не обследовалась, сдавала креатинин 1 раз в год
              на диспансеризации. В апреле 2024 года выявили фибрилляцию
              предсердий, когда проходила стационарное лечение был выполнен
              стресс-тест делали, диагностирована ишемическая болезнь сердца.
              Сахарный диабет отрицает.
            </div>
            <video
              v-if="radioTabs[2] === 1"
              :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/interactive-clinical-case/pacient/11.mp4`"
              :poster="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/step1_video1.jpg
              `"
              controls
            />
            <div v-if="radioTabs[2] === 1" class="text-1 mt-2">
              Аллергии на лекарства отрицает. Принимает периндоприл 5 мг,
              индапамид 1,5 мг, ацетилсалициловую кислоту 75 мг, омега-3 1000
              мг, периодически пропранолол по 20 мг, реже 40 мг при ощущении
              аритмичного сердцебиения.
            </div>
            <video
              v-if="radioTabs[2] === 2"
              :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/interactive-clinical-case/pacient/12.mp4`"
              :poster="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/step1_video1.jpg
              `"
              controls
            />
            <div v-if="radioTabs[2] === 2" class="text-1 mt-2">
              Отец – умер от инфаркта миокарда в 60 лет; мать – страда
              артериальной гипертензией с 45 лет, жива. У детей – гастрит.
            </div>
            <video
              v-if="radioTabs[2] === 3"
              :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/interactive-clinical-case/pacient/13.mp4`"
              :poster="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/step1_video1.jpg
              `"
              controls
            />
            <div v-if="radioTabs[2] === 3" class="text-1 mt-2">
              Беременности – 3, Роды – 2, Замершая беременность – 1. Первая
              беременность без особенностей. Вторые роды были осложнены
              развитием преэклампсией, проходила стационарное лечение, выполнено
              кесарево сечение. Менопауза с 48 лет, отмечала набор массы тела
              после наступления менопаузы. 1 раз в год на диспансеризации
              посещает гинеколога.
            </div>
            <video
              v-if="radioTabs[2] === 4"
              :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/interactive-clinical-case/pacient/14.mp4`"
              :poster="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/step1_video1.jpg
              `"
              controls
            />
            <div v-if="radioTabs[2] === 4" class="text-1 mt-2">
              Курение отрицает. Прием алкоголя эпизодический в небольших
              количествах. Малоподвижный образ жизни, сидячая работа,
              бухгалтером на предприятии, но профессиональных вредностей нет.
              Недавно набрала массу тела, по вечерам гуляет до дома, до
              5000-9000 шагов в день. Диеты держать не может – были срывы, есть
              переедания на работе сладким, особенно на фоне стресса.
            </div>
          </div>
        </div>
      </div>
      <div class="icc__block-container" v-if="activeTab == 3">
        <div class="icc__block-row icc__block-body-scheme">
          <div class="icc__block-text">
            <div class="icc__block-title">Перейти к физикальному осмотру</div>
            <div class="icc__block-description">
              <b>При объективном осмотре в приёмном покое</b>
            </div>
            <div
              class="icc__tabs-tip mt-8 mt-xs-4 mb-xs-4"
              style="justify-content: flex-start"
            >
              <img
                class="mr-2"
                :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/tap.svg`"
              />
              Выберите изображение, чтобы получить больше информации
            </div>
            <div class="icc__body-tabs-container">
              <div class="icc__body-tabs">
                <div
                  class="icc__body-tabs-item"
                  @click="setActiveBody(0)"
                  :class="{ 'icc__body-tabs-item_active': activeBody == 0 }"
                >
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M13.0467 0.0712801C11.2652 0.46374 9.87819 1.81118 9.36684 3.64608C9.23628 4.11442 9.23593 4.12915 9.21686 9.78701C9.19767 15.4584 9.19767 15.4584 8.7575 15.827C7.45624 16.9165 6.50291 18.5643 6.11174 20.3996C5.96333 21.0958 5.96263 22.7486 6.11039 23.451C6.80242 26.7407 9.20471 29.1627 12.4916 29.8849C13.1793 30.036 14.9464 30.039 15.638 29.8901C17.261 29.541 18.6594 28.7875 19.7971 27.6491C20.7301 26.7156 21.3399 25.7247 21.7622 24.4557C22.5362 22.13 22.1876 19.5112 20.8318 17.4655C20.4394 16.8735 19.8062 16.1557 19.3357 15.7696C18.9495 15.4527 18.9495 15.4527 18.9304 9.78414C18.9113 4.1464 18.9105 4.11295 18.7815 3.64608C18.4997 2.6255 17.8739 1.64869 17.1101 1.03735C16.6828 0.695238 15.8386 0.260703 15.3353 0.123741C14.826 -0.0148639 13.5685 -0.0436764 13.0467 0.0712801ZM14.6182 2.29471C15.5736 2.49722 16.3148 3.21331 16.5656 4.17627C16.6436 4.47566 16.6556 5.32237 16.6556 10.5414C16.6556 16.5612 16.6556 16.5612 17.168 16.94C18.2059 17.7072 18.848 18.4278 19.2883 19.3197C19.7333 20.221 19.8993 20.9492 19.8956 21.984C19.8902 23.4934 19.337 24.8564 18.2847 25.9523C15.957 28.377 12.1944 28.3814 9.87186 25.9622C8.79306 24.8385 8.25454 23.4974 8.25096 21.9253C8.24644 19.9539 9.10565 18.343 10.8551 17.0429C11.4916 16.5698 11.4916 16.5698 11.4916 10.5457C11.4916 4.06653 11.4857 4.2035 11.7921 3.60289C11.9666 3.26084 12.4923 2.72678 12.8414 2.53671C13.136 2.3764 13.7158 2.22089 14.0443 2.21408C14.1411 2.21209 14.3993 2.24835 14.6182 2.29471ZM20.7327 3.8767C20.0444 4.28935 20.0546 5.3239 20.7508 5.71524C20.9823 5.84528 21.0086 5.84663 23.3641 5.84663C24.9026 5.84663 25.8019 5.82456 25.9087 5.78419C26.7817 5.45434 26.7817 4.12639 25.9087 3.79654C25.8018 3.75611 24.9016 3.73428 23.3561 3.73463C20.9687 3.73522 20.9687 3.73522 20.7327 3.8767ZM13.5927 7.8442C13.4734 7.90716 13.3017 8.0558 13.2112 8.1744C13.0467 8.39005 13.0467 8.39005 13.0173 13.1104C12.988 17.8307 12.988 17.8307 12.6222 17.9631C12.0544 18.1687 11.626 18.451 11.1066 18.9619C9.79457 20.2523 9.48356 22.1124 10.2979 23.7982C10.524 24.2661 10.647 24.4333 11.1016 24.8905C11.5576 25.3491 11.7222 25.4714 12.1958 25.7036C12.8456 26.0221 13.3784 26.1483 14.0736 26.1483C14.7695 26.1483 15.3021 26.022 15.9514 25.703C16.4207 25.4725 16.5935 25.3446 17.044 24.8949C17.5013 24.4383 17.6182 24.2794 17.8477 23.8031C18.197 23.078 18.3258 22.4524 18.2822 21.6927C18.1883 20.0552 17.162 18.6294 15.634 18.0133C15.1592 17.8219 15.1592 17.8219 15.1299 13.106C15.1005 8.39005 15.1005 8.39005 14.9358 8.17404C14.611 7.74831 14.0398 7.608 13.5927 7.8442ZM20.8502 8.33436C20.6031 8.44198 20.3107 8.79348 20.2354 9.07333C20.1154 9.51878 20.3489 10.0364 20.7659 10.2491C20.9728 10.3546 21.1141 10.3651 22.3306 10.365C23.4879 10.3649 23.6951 10.3511 23.8692 10.2623C24.6443 9.86706 24.6449 8.7635 23.8701 8.36828C23.664 8.26312 23.524 8.25279 22.3353 8.25485C21.3876 8.25655 20.9786 8.27844 20.8502 8.33436ZM20.836 12.868C20.1524 13.205 20.0015 14.0631 20.5326 14.5942C20.8688 14.9304 21.0611 14.9516 23.5905 14.9308C25.7805 14.9129 25.7805 14.9129 26.0536 14.7523C26.7833 14.3234 26.7306 13.2317 25.9634 12.8833C25.7404 12.782 25.5419 12.7736 23.3746 12.7737C21.3371 12.7737 21.0021 12.7862 20.836 12.868Z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
                <div
                  class="icc__body-tabs-item"
                  @click="setActiveBody(1)"
                  :class="{ 'icc__body-tabs-item_active': activeBody == 1 }"
                >
                  <svg
                    width="26"
                    height="26"
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_11_4961)">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M1.72459 0.107333C1.18729 0.251762 0.641165 0.676924 0.322903 1.19847C-0.0294856 1.77609 -0.00551564 0.912815 -0.00551564 13.0271C-0.00551564 25.1415 -0.0294856 24.2782 0.322903 24.8558C0.530203 25.1955 0.841965 25.5048 1.19014 25.7159C1.73942 26.0491 0.933985 26.0278 12.9951 26.0278C25.1095 26.0278 24.2462 26.0518 24.8238 25.6994C25.1635 25.4921 25.4728 25.1803 25.6839 24.8321C26.0171 24.2829 25.9958 25.0883 25.9958 13.0271C25.9958 0.965986 26.0171 1.77142 25.6839 1.22214C25.4728 0.873966 25.1635 0.562204 24.8238 0.354904C24.2459 0.00231218 25.1137 0.0261298 12.9718 0.029837C3.51964 0.0327317 1.96226 0.0434471 1.72459 0.107333ZM13.9673 3.63259C16.2477 3.85487 18.3375 4.76334 20.0599 6.28112C20.6512 6.80216 20.7682 7.0442 20.5912 7.37998C20.5514 7.45539 19.733 8.29983 18.7726 9.25644C17.0263 10.9958 17.0263 10.9958 16.7721 10.9958C16.5374 10.9958 16.4914 10.9735 16.1659 10.7031C15.3225 10.0022 14.5822 9.6848 13.5131 9.56592C13.0559 9.51508 12.8681 9.51732 12.4151 9.57907C11.8688 9.65352 11.8688 9.65352 11.7793 9.47405C11.7301 9.37533 11.4418 8.74606 11.1386 8.07572C10.5259 6.72101 10.3926 6.52681 10.0753 6.52681C9.73665 6.52681 9.44027 6.80054 9.44027 7.11331C9.44027 7.18985 9.72954 7.88924 10.0831 8.6675C10.4367 9.44576 10.7166 10.09 10.7052 10.099C10.6938 10.1081 10.5474 10.1979 10.3798 10.2987C10.2122 10.3994 9.93892 10.5974 9.77255 10.7388C9.4972 10.9727 9.44733 10.9958 9.21708 10.9958C8.96402 10.9958 8.96402 10.9958 7.21772 9.25644C6.25725 8.29983 5.43886 7.45539 5.3991 7.37998C5.22207 7.0442 5.33907 6.80216 5.93035 6.28112C8.15864 4.31756 11.0887 3.35201 13.9673 3.63259Z"
                        fill="currentColor"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_11_4961">
                        <rect width="26" height="26" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div
                  class="icc__body-tabs-item"
                  @click="setActiveBody(2)"
                  :class="{ 'icc__body-tabs-item_active': activeBody == 2 }"
                >
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_11_4967)">
                      <path
                        d="M0.474291 13.4823C0.799756 14.014 1.27285 14.4397 1.83612 14.7075C2.10322 14.8346 2.21674 15.1543 2.08949 15.4216C1.96223 15.6887 1.64249 15.8023 1.37539 15.675C1.16116 15.5713 0.95608 15.45 0.761992 15.3122C1.34952 17.054 2.98165 18.2279 4.82 18.2309H4.85205C4.82115 17.9352 4.81428 17.6376 4.83122 17.341C5.06857 14.4844 7.47637 12.2986 10.3426 12.338H13.3913C13.6872 12.338 13.9268 12.0981 13.9268 11.8024C13.9268 10.9148 14.6464 10.1952 15.534 10.1952H17.1412C17.4371 10.1952 17.6768 10.4351 17.6768 10.731C17.6768 11.0267 17.4371 11.2666 17.1412 11.2666H15.534C15.2381 11.2666 14.9985 11.5064 14.9985 11.8024C14.9985 12.69 14.2789 13.4093 13.3913 13.4093H10.3426C8.04124 13.3688 6.10104 15.1161 5.901 17.409C5.8749 17.8146 5.90626 18.2217 5.99415 18.6186C6.01727 18.7257 6.0445 18.8264 6.07517 18.9278C6.08089 18.9475 6.08685 18.9679 6.09325 18.9878C6.12644 19.0949 6.16352 19.1968 6.20472 19.2979L6.21754 19.3284C6.73114 20.5572 7.78238 21.4807 9.06707 21.8318L9.10621 21.8419C9.20417 21.8678 9.30373 21.889 9.40444 21.9078C9.45479 21.917 9.50629 21.9238 9.5571 21.9314C9.63011 21.9421 9.70244 21.9534 9.77636 21.9605C9.90866 21.9726 10.0442 21.9808 10.1769 21.9808C11.5325 21.9772 12.8067 21.3333 13.6142 20.2446C13.3604 20.0825 13.1168 19.9054 12.8845 19.7142C12.657 19.525 12.6259 19.1871 12.8152 18.9596C13.0042 18.7321 13.3421 18.701 13.5696 18.8903C15.0497 20.1216 17.0046 20.6234 18.8949 20.2569C20.7852 19.8903 22.4107 18.6941 23.3232 16.9986C23.0357 16.6079 22.8167 16.1712 22.6755 15.707C22.5938 15.4244 22.7554 15.1284 23.0376 15.0447C23.3196 14.9607 23.6166 15.1202 23.7025 15.4017C24.1176 16.81 25.4344 17.758 26.9017 17.7049C28.3691 17.6518 29.6139 16.6111 29.9261 15.1765C30.2385 13.7419 29.5391 12.278 28.2265 11.6197C28.1583 11.9312 28.0667 12.2372 27.9527 12.5352C27.8452 12.8108 27.5343 12.9472 27.2585 12.8394C26.9827 12.7319 26.8466 12.4208 26.9541 12.1452C27.1224 11.7122 27.2329 11.259 27.2826 10.7974C27.2913 10.7234 27.2965 10.6543 27.3018 10.5831C27.311 10.4538 27.3197 10.3254 27.3197 10.1952C27.3197 7.87254 25.8198 5.81584 23.6082 5.10609C23.7766 5.36083 23.9263 5.6277 24.0561 5.90419C24.1453 6.07928 24.1314 6.28939 24.0199 6.45121C23.9085 6.61302 23.7171 6.70091 23.5217 6.68008C23.3262 6.65903 23.158 6.53269 23.0831 6.35096C21.9126 3.84176 19.0279 2.63168 16.4175 3.55521C16.0225 3.69116 15.645 3.87312 15.2926 4.09719C15.0445 4.25878 14.7126 4.18874 14.551 3.94087C14.3894 3.69299 14.4594 3.36089 14.7075 3.1993C14.7883 3.14574 14.873 3.09974 14.9561 3.05053C13.8216 2.51175 12.4904 2.5898 11.4268 3.25789C11.6751 3.47739 11.8972 3.72504 12.0885 3.99603C12.2027 4.15281 12.2231 4.35903 12.142 4.53526C12.061 4.7115 11.891 4.83029 11.6976 4.84539C11.5042 4.86073 11.3176 4.77009 11.2098 4.60873C10.9571 4.24871 10.6335 3.94384 10.2591 3.71313H10.254C8.85948 2.84591 7.03417 3.18053 6.03809 4.48628C6.25004 4.54671 6.45694 4.62384 6.65698 4.71699C6.83436 4.79641 6.95498 4.96556 6.97215 5.15919C6.98908 5.35282 6.90005 5.5405 6.73915 5.64967C6.57825 5.75862 6.37088 5.77212 6.19716 5.68446C5.32972 5.27454 4.32448 5.2734 3.45612 5.68172C2.58798 6.08981 1.94735 6.86456 1.70955 7.79426C1.99771 7.68463 2.29662 7.60658 2.60149 7.56172C2.89468 7.51984 3.16613 7.72377 3.20779 8.01673C3.24944 8.3097 3.04574 8.58115 2.75255 8.6228C2.26275 8.6933 1.79606 8.87663 1.38935 9.15861L1.38225 9.16456C-0.0132193 10.1286 -0.414901 12.0139 0.466739 13.4629C0.469943 13.4704 0.471087 13.4769 0.474291 13.4823Z"
                        fill="currentColor"
                      />
                      <path
                        d="M22.7661 23.5885C25.5721 23.5885 27.8552 21.7865 27.8552 19.5707C27.8543 19.2622 27.8083 18.9553 27.7186 18.66C26.4444 18.9503 25.1075 18.6378 24.094 17.8125C22.8407 19.8784 20.6741 21.2194 18.2661 21.4194C19.0425 22.5061 20.2173 23.2415 21.534 23.4649C21.9392 23.5486 22.3523 23.5901 22.7661 23.5885Z"
                        fill="currentColor"
                      />
                      <path
                        d="M17.0341 21.4105C16.2811 21.3444 15.5423 21.1654 14.8424 20.879C14.8229 20.8768 14.8037 20.8729 14.7847 20.8678C14.7312 20.8449 14.6776 20.8175 14.624 20.7939C14.6025 20.7843 14.5794 20.7779 14.5581 20.7676C14.372 21.0296 14.1626 21.2743 13.9324 21.4984C13.9612 22.3629 14.6691 23.0495 15.5341 23.052C16.0129 23.0417 16.4725 23.2408 16.7924 23.5972L19.891 27.1464C20.0013 27.2666 20.1565 27.3359 20.3195 27.3375C20.6342 27.3384 20.89 27.0844 20.8912 26.7697V24.4051C19.2286 24.0206 17.8185 22.9259 17.0341 21.4105Z"
                        fill="currentColor"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_11_4967">
                        <rect width="30" height="30" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div
                  class="icc__body-tabs-item"
                  @click="setActiveBody(3)"
                  :class="{ 'icc__body-tabs-item_active': activeBody == 3 }"
                >
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_11_4973)">
                      <path
                        d="M9.54644 4.06121C9.60033 3.96319 9.62306 3.85107 9.61159 3.7398C9.60012 3.62853 9.55501 3.5234 9.48226 3.43843C9.40951 3.35346 9.31259 3.29268 9.20441 3.26421C9.09624 3.23574 8.98195 3.24092 8.8768 3.27907C5.59823 4.538 4.16251 7.5005 3.56787 9.32728H7.49466C7.93447 7.48633 8.62484 5.71444 9.54644 4.06121Z"
                        fill="currentColor"
                      />
                      <path
                        d="M3.06964 15.0163C3.81968 15.0357 4.56129 14.8544 5.21786 14.4913C6.0225 14.0546 6.92763 13.8366 7.84286 13.8592C8.75615 13.8388 9.65901 14.0566 10.4625 14.4913C10.815 14.682 11.1916 14.8244 11.5821 14.9145C12.1768 13.5377 11.9036 11.8717 12.2464 10.3984H1.63929C1.20452 10.3984 0.787561 10.5711 0.480136 10.8786C0.17271 11.186 0 11.603 0 12.0377V14.1002C1.18169 14.5079 1.56118 15.021 3.06964 15.0163Z"
                        fill="currentColor"
                      />
                      <path
                        d="M26.7481 4.06111C26.8019 3.96308 26.8246 3.85099 26.8131 3.73975C26.8016 3.62851 26.7565 3.52342 26.6838 3.43847C26.611 3.35352 26.5141 3.29275 26.406 3.26426C26.2979 3.23576 26.1836 3.24089 26.0785 3.27897C22.7999 4.5379 21.3642 7.5004 20.7695 9.32718H24.6963C25.1361 7.48624 25.8265 5.71435 26.7481 4.06111Z"
                        fill="currentColor"
                      />
                      <path
                        d="M28.3607 10.3984H16.5911C16.65 11.7109 16.4625 12.4181 16.7196 13.8859C17.8499 13.7639 18.9911 13.9743 20.0036 14.4913C20.6671 14.8362 21.4039 15.0163 22.1518 15.0163C22.8996 15.0163 23.6365 14.8362 24.3 14.4913C25.9018 13.5592 28.3071 13.6984 30 14.7002V12.0377C30 11.8224 29.9576 11.6093 29.8752 11.4104C29.7928 11.2115 29.6721 11.0308 29.5199 10.8786C29.3676 10.7264 29.1869 10.6056 28.988 10.5232C28.7892 10.4408 28.576 10.3984 28.3607 10.3984Z"
                        fill="currentColor"
                      />
                      <path
                        d="M26.9304 14.9518C24.6324 14.9755 24.6202 16.1289 22.1464 16.1089C19.6875 16.125 19.6714 14.9732 17.3839 14.9518C16.8161 14.8714 17.1429 15.1929 17.2768 15.5304C18.6589 18.1339 17.4857 21.4714 14.3411 21.3964C11.7536 21.4554 10.0339 18.6322 11.1 15.9214C9.80357 15.5464 9.46607 14.9411 7.84286 14.9518C5.55 14.9732 5.54464 16.125 3.06964 16.1089C1.65 16.1089 1.05536 15.7554 0 15.2625V24.525C1.69286 23.5232 4.09821 23.3893 5.68929 24.3214C6.3472 24.6856 7.09129 24.8651 7.84286 24.8411C8.59089 24.8639 9.33121 24.6843 9.98571 24.3214C10.8003 23.9125 11.6992 23.6996 12.6107 23.6996C13.5222 23.6996 14.4211 23.9126 15.2357 24.3216C15.89 24.6851 16.6305 24.8646 17.3786 24.8411C19.6739 24.8217 19.6818 23.67 22.1518 23.6893C24.6181 23.6708 24.6343 24.8225 26.9304 24.8411C28.4357 24.8572 28.8161 24.3268 30 23.9357V15.8625C28.8158 15.4574 28.4435 14.9405 26.9304 14.9518ZM4.84286 22.2857C4.7017 22.2843 4.56681 22.2273 4.4675 22.1269C4.36818 22.0266 4.31247 21.8912 4.31247 21.75C4.31247 21.6089 4.36818 21.4734 4.4675 21.3731C4.56681 21.2728 4.7017 21.2157 4.84286 21.2143C4.98401 21.2157 5.1189 21.2728 5.21822 21.3731C5.31753 21.4734 5.37324 21.6089 5.37324 21.75C5.37324 21.8912 5.31753 22.0266 5.21822 22.1269C5.1189 22.2273 4.98401 22.2843 4.84286 22.2857ZM4.10893 20.0036C3.68338 19.9982 3.27708 19.8254 2.97805 19.5226C2.67902 19.2198 2.51134 18.8113 2.51134 18.3857C2.51134 17.9601 2.67902 17.5517 2.97805 17.2489C3.27708 16.9461 3.68338 16.7732 4.10893 16.7679C4.53448 16.7732 4.94078 16.9461 5.23981 17.2489C5.53884 17.5517 5.70652 17.9601 5.70652 18.3857C5.70652 18.8113 5.53884 19.2198 5.23981 19.5226C4.94078 19.8254 4.53448 19.9982 4.10893 20.0036ZM8.43214 16.6607C8.57422 16.6607 8.71048 16.7172 8.81095 16.8176C8.91142 16.9181 8.96786 17.0544 8.96786 17.1964C8.96786 17.3385 8.91142 17.4748 8.81095 17.5753C8.71048 17.6757 8.57422 17.7322 8.43214 17.7322C8.29006 17.7322 8.1538 17.6757 8.05334 17.5753C7.95287 17.4748 7.89643 17.3385 7.89643 17.1964C7.89643 17.0544 7.95287 16.9181 8.05334 16.8176C8.1538 16.7172 8.29006 16.6607 8.43214 16.6607ZM9.50357 23.1107C9.07755 23.1061 8.67055 22.9336 8.37094 22.6307C8.07133 22.3278 7.90328 21.9189 7.90328 21.4929C7.90328 21.0668 8.07133 20.658 8.37094 20.3551C8.67055 20.0522 9.07755 19.8797 9.50357 19.875C9.92959 19.8797 10.3366 20.0522 10.6362 20.3551C10.9358 20.658 11.1039 21.0668 11.1039 21.4929C11.1039 21.9189 10.9358 22.3278 10.6362 22.6307C10.3366 22.9336 9.92959 23.1061 9.50357 23.1107ZM20.8286 16.6768C20.9687 16.6798 21.102 16.7376 21.2 16.8377C21.298 16.9378 21.3529 17.0724 21.3529 17.2125C21.3529 17.3526 21.298 17.4872 21.2 17.5873C21.102 17.6875 20.9687 17.7452 20.8286 17.7482C20.6885 17.7452 20.5551 17.6875 20.4571 17.5873C20.3591 17.4872 20.3042 17.3526 20.3042 17.2125C20.3042 17.0724 20.3591 16.9378 20.4571 16.8377C20.5551 16.7376 20.6885 16.6798 20.8286 16.6768ZM19.7518 23.1268C19.3262 23.1214 18.9199 22.9486 18.6209 22.6458C18.3219 22.343 18.1542 21.9345 18.1542 21.5089C18.1542 21.0834 18.3219 20.6749 18.6209 20.3721C18.9199 20.0693 19.3262 19.8965 19.7518 19.8911C20.1773 19.8965 20.5836 20.0693 20.8827 20.3721C21.1817 20.6749 21.3494 21.0834 21.3494 21.5089C21.3494 21.9345 21.1817 22.343 20.8827 22.6458C20.5836 22.9486 20.1773 23.1214 19.7518 23.1268ZM24.4179 22.3072C24.2762 22.3055 24.1408 22.248 24.0412 22.1472C23.9416 22.0465 23.8858 21.9105 23.8858 21.7688C23.8858 21.6271 23.9416 21.4911 24.0412 21.3903C24.1408 21.2895 24.2762 21.232 24.4179 21.2304C24.5595 21.232 24.6949 21.2895 24.7945 21.3903C24.8941 21.4911 24.9499 21.6271 24.9499 21.7688C24.9499 21.9105 24.8941 22.0465 24.7945 22.1472C24.6949 22.248 24.5595 22.3055 24.4179 22.3072ZM25.1518 20.0197C24.7257 20.0162 24.3182 19.8445 24.0182 19.542C23.7181 19.2394 23.5497 18.8306 23.5497 18.4045C23.5497 17.9784 23.7181 17.5695 24.0182 17.267C24.3182 16.9645 24.7257 16.7928 25.1518 16.7893C25.5779 16.7928 25.9853 16.9645 26.2854 17.267C26.5855 17.5695 26.7539 17.9784 26.7539 18.4045C26.7539 18.8306 26.5855 19.2394 26.2854 19.542C25.9853 19.8445 25.5779 20.0162 25.1518 20.0197Z"
                        fill="currentColor"
                      />
                      <path
                        d="M26.928 25.9341C24.4603 25.9554 24.441 24.8033 22.1535 24.7772C19.8585 24.8032 19.8501 25.9556 17.379 25.934C14.9181 25.9561 14.8993 24.8047 12.6101 24.7772C10.3216 24.8026 10.3036 25.9549 7.84104 25.934C6.9259 25.956 6.02098 25.7378 5.21645 25.3011C4.561 24.9388 3.82071 24.7579 3.07202 24.7773C2.38519 24.7564 1.70412 24.9084 1.09131 25.2192C0.74016 25.4035 0.375306 25.5604 0 25.6885V27.7565C0.000339093 28.1906 0.172913 28.6068 0.479829 28.9137C0.786745 29.2206 1.20292 29.3932 1.63696 29.3935H28.363C28.7971 29.3932 29.2133 29.2206 29.5202 28.9137C29.8271 28.6068 29.9997 28.1906 30 27.7565V25.0938C28.9384 25.5853 28.3533 25.9327 26.928 25.9341Z"
                        fill="currentColor"
                      />
                      <path
                        d="M12.7179 19.7089C13.19 20.1004 13.7868 20.3095 14.4 20.2982C16.6946 20.3727 17.2789 17.8399 16.2964 16.0178C15.806 15.019 15.5356 13.9265 15.5036 12.8143C15.5035 12.085 15.5037 10.0271 15.5036 9.32679C15.3466 5.69179 16.412 2.07952 17.2608 0.605408C14.3624 3.37172 13.3044 9.42738 13.0286 13.575C12.954 14.4148 12.702 15.2291 12.2893 15.9643C11.9584 16.5544 11.8216 17.2337 11.8986 17.9059C11.9755 18.578 12.2622 19.2089 12.7179 19.7089Z"
                        fill="currentColor"
                      />
                      <path
                        d="M25.1491 17.881C25.0105 17.8815 24.8776 17.9369 24.7798 18.0351C24.6819 18.1333 24.6269 18.2662 24.627 18.4049C24.627 18.5435 24.6819 18.6765 24.7798 18.7747C24.8777 18.8729 25.0105 18.9283 25.1491 18.9287C25.2878 18.9283 25.4206 18.8729 25.5184 18.7747C25.6163 18.6765 25.6713 18.5435 25.6713 18.4049C25.6713 18.2662 25.6163 18.1332 25.5184 18.035C25.4205 17.9369 25.2877 17.8815 25.1491 17.881Z"
                        fill="currentColor"
                      />
                      <path
                        d="M4.1088 17.8592C3.97095 17.8619 3.83966 17.9186 3.74313 18.017C3.64659 18.1155 3.59253 18.2479 3.59253 18.3858C3.59253 18.5236 3.64661 18.656 3.74315 18.7545C3.83969 18.8529 3.97098 18.9096 4.10884 18.9123C4.24669 18.9096 4.37798 18.8529 4.47451 18.7544C4.57105 18.656 4.62512 18.5236 4.62511 18.3857C4.62511 18.2478 4.57103 18.1155 4.47449 18.017C4.37796 17.9186 4.24666 17.8619 4.1088 17.8592Z"
                        fill="currentColor"
                      />
                      <path
                        d="M9.5053 20.9648C9.36688 20.9667 9.23477 21.023 9.13756 21.1216C9.04034 21.2201 8.98583 21.353 8.98584 21.4914C8.98584 21.6299 9.04036 21.7627 9.13758 21.8613C9.23481 21.9598 9.36692 22.0161 9.50534 22.018C9.64376 22.0161 9.77587 21.9598 9.87309 21.8612C9.9703 21.7627 10.0248 21.6298 10.0248 21.4914C10.0248 21.353 9.97028 21.2201 9.87306 21.1216C9.77584 21.023 9.64372 20.9667 9.5053 20.9648Z"
                        fill="currentColor"
                      />
                      <path
                        d="M19.7526 20.9803C19.6148 20.9831 19.4835 21.0397 19.3869 21.1382C19.2904 21.2367 19.2363 21.369 19.2363 21.5069C19.2363 21.6448 19.2904 21.7772 19.387 21.8757C19.4835 21.9741 19.6148 22.0308 19.7527 22.0335C19.8905 22.0308 20.0218 21.9741 20.1184 21.8756C20.2149 21.7772 20.269 21.6448 20.269 21.5069C20.269 21.369 20.2149 21.2366 20.1183 21.1382C20.0218 21.0397 19.8905 20.9831 19.7526 20.9803Z"
                        fill="currentColor"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_11_4973">
                        <rect width="30" height="30" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div
                  class="icc__body-tabs-item"
                  @click="setActiveBody(4)"
                  :class="{ 'icc__body-tabs-item_active': activeBody == 4 }"
                >
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_11_4987)">
                      <path
                        d="M4.34376 29.8444C4.4579 29.9585 4.61427 30.0186 4.76998 30.0186C4.92042 30.0186 5.07613 29.9585 5.19027 29.8444L6.71572 28.3189C8.83629 26.1984 11.7196 24.667 15.0588 23.8917C17.7376 23.2669 18.8309 21.5732 18.8731 21.5013C18.9932 21.3093 18.9991 21.0685 18.885 20.8765C18.7708 20.6845 18.5603 20.5703 18.332 20.5822C17.2025 20.6422 16.0914 20.3302 15.1967 19.6934C14.2954 19.0686 13.6231 18.1436 13.2925 17.0985C13.2325 16.9124 13.088 16.7679 12.9019 16.7079C12.1333 16.4677 11.4306 16.0408 10.8658 15.4767C10.6375 15.2484 10.4574 15.032 10.2951 14.7918C9.66434 13.9031 9.35225 12.7913 9.41823 11.6624C9.43011 11.4401 9.31596 11.2296 9.12396 11.1161C8.92603 11.002 8.6852 11.002 8.49914 11.1221C8.42722 11.1702 6.73287 12.2576 6.10871 14.9423C5.32157 18.3244 3.83242 21.1351 1.68149 23.2854L0.155387 24.8049C0.0412424 24.919 -0.0187988 25.0754 -0.0187988 25.2311C-0.0187988 25.3934 0.0412424 25.5432 0.155387 25.6573L4.34376 29.8444Z"
                        fill="currentColor"
                      />
                      <path
                        d="M25.626 0.158031C25.3918 -0.0761959 25.0131 -0.0761959 24.7788 0.158031L19.5282 5.47399C18.429 6.57321 16.7597 7.18022 14.9453 7.19209C13.7082 7.19803 12.5667 7.76875 11.804 8.75976C10.7589 10.1236 10.7166 12.0574 11.6958 13.4628C12.4288 14.5079 13.5881 15.1208 14.8252 15.169C14.8734 16.4127 15.4916 17.566 16.5314 18.2984C17.2103 18.7728 18.0094 19.007 18.8077 19.007C19.6727 19.007 20.5317 18.7365 21.2344 18.1902C22.2254 17.4334 22.7962 16.286 22.808 15.0489C22.814 13.2351 23.421 11.6371 24.5202 10.5379L29.8362 5.22195C29.9503 5.1078 30.0163 4.95737 30.0163 4.79572C30.0163 4.63935 29.9503 4.48364 29.8362 4.36949L25.626 0.158031Z"
                        fill="currentColor"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_11_4987">
                        <rect width="30" height="30" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div
                  class="icc__body-tabs-item"
                  @click="setActiveBody(5)"
                  :class="{ 'icc__body-tabs-item_active': activeBody == 5 }"
                >
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_11_4992)">
                      <path
                        d="M11.1362 10.5213C11.238 10.5567 11.3296 10.5895 11.426 10.6232C11.498 10.6484 11.5716 10.6737 11.642 10.6992C11.6556 10.7041 11.6714 10.7094 11.685 10.7143H12.0153C12.2706 9.92766 12.6574 9.19008 13.1594 8.53277C13.1809 8.50283 13.2018 8.47307 13.2237 8.44318C13.3165 8.31674 13.4113 8.19293 13.5081 8.0717C13.5557 8.01188 13.6051 7.95334 13.6541 7.8941C13.7263 7.80668 13.7988 7.72131 13.872 7.63805C13.9156 7.58842 13.9593 7.53937 14.0039 7.49045C14.0701 7.41768 14.1357 7.34771 14.2016 7.27898C14.2545 6.07312 14.7479 4.28572 16.3392 4.28572C16.6351 4.28572 16.875 4.52555 16.875 4.82145C16.875 5.11729 16.6351 5.35717 16.3392 5.35717C15.8915 5.35717 15.6306 5.76164 15.4786 6.21908C15.5121 6.19834 15.5458 6.18434 15.5793 6.16459C15.6936 6.09727 15.8079 6.03539 15.9221 5.97896C16.0063 5.93736 16.0905 5.89887 16.1748 5.86266C16.2744 5.81953 16.374 5.78004 16.4734 5.74418C16.5377 5.72109 16.602 5.69666 16.6664 5.67621C16.8061 5.63162 16.9453 5.59441 17.0841 5.56143C17.138 5.54877 17.1918 5.5367 17.2457 5.52563C17.3992 5.49357 17.5521 5.46639 17.7039 5.44553C17.728 5.4423 17.7521 5.43979 17.7761 5.43674C18.1345 5.39303 18.4949 5.36836 18.8559 5.36273L18.8656 5.36232C18.9622 5.01141 19.0133 4.64959 19.0178 4.28566C19.0178 3.19957 18.0968 2.20348 16.7261 1.80744C16.4969 1.74105 16.3392 1.53123 16.3392 1.29264V0.535723C16.3392 0.239883 16.0994 0 15.8035 0C15.5076 0 15.2677 0.239824 15.2677 0.535723V1.09758C15.2677 1.37496 15.0559 1.60646 14.7796 1.63119C14.3643 1.66453 13.9562 1.75846 13.5682 1.91004C13.4363 1.96301 13.2887 1.96137 13.158 1.90541C13.0273 1.84945 12.9242 1.74387 12.8714 1.61186L12.404 0.443672C12.3334 0.267949 12.1376 0.178184 11.9584 0.239531C11.7792 0.300879 11.6795 0.491719 11.7314 0.673828L12.2394 2.4515C12.2891 2.62482 12.2481 2.81145 12.1303 2.94797C11.0129 4.24646 10.4463 6.51539 10.4463 9.69094V10.2778L10.4577 10.282C10.6942 10.3686 10.9214 10.4471 11.1362 10.5213Z"
                        fill="currentColor"
                      />
                      <path
                        d="M6.66624 19.6531C6.72448 19.5795 6.78694 19.5094 6.85327 19.443C7.10048 19.1956 7.49962 18.8696 8.00499 18.4569C9.60718 17.148 12.5892 14.7116 12.5892 12.8575C12.5894 12.7866 12.5826 12.7159 12.5687 12.6464C12.5659 12.6321 12.5615 12.621 12.5582 12.6077C12.5458 12.5562 12.5278 12.5062 12.5045 12.4586C12.5002 12.4503 12.4963 12.4413 12.4919 12.4335C12.4708 12.3992 12.447 12.3666 12.4206 12.3362C12.347 12.2836 12.2768 12.2264 12.2104 12.1649C12.1947 12.1491 12.1854 12.1295 12.1709 12.1129C11.8863 11.945 11.5842 11.8085 11.2702 11.7057C11.1936 11.6779 11.1121 11.6494 11.0314 11.6212C10.9482 11.592 10.8713 11.5643 10.7799 11.5329C10.0339 11.2919 9.30536 10.9996 8.5996 10.6581C8.59222 10.6544 8.57827 10.6523 8.56895 10.649C8.56128 10.6472 8.55331 10.6488 8.54569 10.6466C8.22419 10.5566 7.39368 10.7256 6.53675 11.5711C6.53089 11.5769 6.52274 11.5788 6.51665 11.5843C5.64067 12.4575 4.55347 14.2336 4.55347 17.6789C4.55347 21.125 4.86712 22.1917 5.01753 22.5051C5.04132 22.5019 5.06522 22.5003 5.08919 22.5004C5.13495 22.5001 5.18071 22.4967 5.22601 22.4902C5.2297 22.4896 5.23251 22.4868 5.2362 22.4863C5.46741 22.4514 5.603 22.3115 5.72452 22.0208L5.72774 22.0129C5.81464 21.7854 5.88817 21.553 5.94794 21.317C6.07087 20.7279 6.30999 20.1693 6.65142 19.6739C6.65669 19.6671 6.66091 19.6599 6.66624 19.6531Z"
                        fill="currentColor"
                      />
                      <path
                        d="M19.5636 11.3787C19.5544 11.4175 19.5487 11.4568 19.538 11.4952L19.5369 11.4984C19.5355 11.5036 19.5318 11.5075 19.5302 11.5127C19.5024 11.6106 19.4674 11.7059 19.4302 11.8009C19.4209 11.8246 19.4144 11.849 19.4046 11.8725C19.4028 11.8766 19.3996 11.8794 19.3978 11.8835C19.3522 11.9886 19.3001 12.0907 19.2418 12.1893C19.2296 12.2104 19.2198 12.2325 19.207 12.2533C19.2049 12.2568 19.2017 12.2592 19.1994 12.2627C19.1766 12.299 19.1584 12.3373 19.1336 12.3727C19.1218 12.3896 19.1057 12.4041 19.0935 12.4208C19.0234 12.5194 18.9457 12.6124 18.8612 12.699L18.861 12.6992L18.8607 12.6996L18.8601 12.7004L18.8599 12.7006L18.8597 12.701C18.787 12.7727 18.724 12.8536 18.6723 12.9417L18.665 12.9531C18.6483 12.9839 18.6343 13.016 18.6231 13.0491C18.614 13.0721 18.6067 13.0957 18.6011 13.1199C18.5969 13.1396 18.5943 13.1596 18.5932 13.1797C18.5904 13.2232 18.5963 13.2668 18.6105 13.3079C18.6171 13.3254 18.6249 13.3423 18.6339 13.3586C18.6391 13.3683 18.6452 13.378 18.6513 13.3877C18.6679 13.4143 18.6867 13.4395 18.7074 13.4631C18.7166 13.4736 18.7271 13.4838 18.7374 13.4942C18.7604 13.5179 18.7849 13.5404 18.8105 13.5614C18.8281 13.5755 18.848 13.589 18.8674 13.6027C18.8922 13.6203 18.9168 13.6378 18.9447 13.6545C18.9767 13.6736 19.012 13.6912 19.0477 13.7089C19.0686 13.7193 19.0882 13.7302 19.1104 13.7401C19.1611 13.7625 19.2161 13.7829 19.2731 13.802C19.2856 13.8062 19.2966 13.8112 19.3094 13.8151C19.3766 13.8363 19.4484 13.8546 19.5234 13.8704L19.5414 13.8749C19.6182 13.8904 19.6995 13.9022 19.7835 13.9112C19.7903 13.9119 19.7964 13.9133 19.8033 13.914C19.8946 13.9231 19.99 13.9279 20.0891 13.9279C20.2419 13.9279 20.3746 13.9213 20.4978 13.9118C20.5201 13.9101 20.5433 13.9087 20.5648 13.9067C20.6773 13.8962 20.7778 13.8821 20.8669 13.8648C20.8879 13.8607 20.9068 13.8559 20.9268 13.8514C20.9895 13.8378 21.0513 13.8208 21.1122 13.8006C21.1301 13.7946 21.15 13.7892 21.1668 13.7829C21.2194 13.7632 21.2704 13.7393 21.3193 13.7116C21.3375 13.7013 21.3536 13.6904 21.3701 13.6796C21.4006 13.6599 21.4294 13.638 21.4566 13.6141C21.4626 13.6088 21.4691 13.6037 21.4748 13.5983C21.549 13.5233 21.6024 13.4303 21.63 13.3284C21.6401 13.3025 21.6523 13.2775 21.6664 13.2535C21.6908 13.1227 21.7007 12.9895 21.6961 12.8565C21.5814 11.5553 20.8164 10.4004 19.6631 9.78711C19.6671 9.83246 19.6687 9.88373 19.6718 9.9316C19.6735 9.95826 19.6751 9.98451 19.6765 10.0115C19.6805 10.0913 19.6822 10.1733 19.6828 10.2583L19.6835 10.283C19.6836 10.289 19.6863 10.2949 19.6862 10.3009L19.6842 10.3096C19.6842 10.3231 19.6852 10.3358 19.6852 10.3493L19.6853 10.3501V10.3545C19.6852 10.3722 19.6844 10.3899 19.6841 10.4077L19.683 10.4562L19.6824 10.4844L19.6819 10.5049C19.6803 10.5457 19.6785 10.5865 19.6759 10.6273C19.6757 10.6313 19.6733 10.6345 19.673 10.6385C19.6688 10.7085 19.6643 10.7779 19.657 10.8484L19.6548 10.8665L19.6539 10.8747C19.6489 10.9166 19.6434 10.9585 19.6376 11.0003L19.6374 11.0019V11.0024L19.6346 11.0108C19.629 11.0497 19.6252 11.0885 19.6185 11.1273L19.6186 11.1285H19.6184C19.6042 11.2127 19.5838 11.2955 19.5636 11.3787Z"
                        fill="currentColor"
                      />
                      <path
                        d="M18.1396 6.47161C18.0003 6.48432 17.8636 6.5036 17.7275 6.52475C17.6777 6.53266 17.6278 6.53958 17.5781 6.54883C17.4622 6.5701 17.3476 6.59788 17.2333 6.62729C17.1661 6.64487 17.0988 6.66262 17.0317 6.68342C16.9257 6.716 16.8204 6.7542 16.7154 6.79575C16.6472 6.82282 16.5791 6.85194 16.5112 6.88299C16.4003 6.93379 16.2898 6.98928 16.1795 7.05221C16.1262 7.08239 16.073 7.11608 16.0198 7.1493C15.8884 7.23063 15.7612 7.31846 15.6387 7.4125C15.6111 7.43377 15.5835 7.45827 15.5559 7.48047C15.4007 7.60493 15.2522 7.73752 15.111 7.87768L15.1103 7.87838C14.9645 8.02428 14.8254 8.17422 14.6916 8.32569C14.6783 8.34069 14.6648 8.35563 14.6516 8.37063C14.2687 8.80786 13.9243 9.27743 13.6223 9.77413L13.6017 9.80817C13.522 9.9417 13.4511 10.0709 13.386 10.1964C13.3706 10.2262 13.3557 10.2556 13.3411 10.2847C13.2813 10.4042 13.2269 10.5201 13.1819 10.6288C13.1766 10.6414 13.1721 10.6533 13.1669 10.6656C13.0792 10.8658 13.0203 11.0775 12.9922 11.2942C12.9912 11.3061 12.9847 11.3158 12.9829 11.3275C12.982 11.3463 12.9824 11.3652 12.9838 11.384C13.0583 11.4422 13.1286 11.5055 13.1942 11.5735C13.5527 11.7875 13.9376 11.9538 14.3392 12.0681C14.373 12.0783 14.4068 12.0884 14.4411 12.0981C14.5258 12.1222 14.6107 12.1445 14.6959 12.1653C14.7479 12.178 14.7999 12.1896 14.852 12.2009C14.927 12.2173 15.0017 12.2328 15.0755 12.2461C15.1412 12.2578 15.2058 12.2668 15.2705 12.2758C15.3303 12.2843 15.3909 12.2938 15.4486 12.2998C15.5709 12.3122 15.6908 12.3206 15.8035 12.3206C16.1564 12.3206 16.492 12.3087 16.8161 12.2896C16.8568 12.2872 16.8988 12.2858 16.939 12.2831C17.2423 12.2628 17.5295 12.2328 17.8042 12.1957C17.8336 12.1917 17.8629 12.1877 17.8921 12.1834L17.8956 12.1795L17.8961 12.1783L17.8993 12.1748C17.96 12.0963 18.0254 12.0215 18.0951 11.951L18.1035 11.9413L18.1059 11.9384C18.1813 11.8598 18.2471 11.7725 18.3017 11.6782C18.3197 11.6488 18.3353 11.6179 18.3514 11.5872C18.393 11.5076 18.4288 11.4251 18.4585 11.3403C18.4642 11.3244 18.4703 11.3087 18.4756 11.2927C18.479 11.2822 18.4826 11.2718 18.4858 11.2613C18.5196 11.1517 18.5462 11.0399 18.5655 10.9268L18.5691 10.9086C18.5883 10.7871 18.6012 10.6646 18.6077 10.5418C18.6087 10.5225 18.6094 10.5035 18.6102 10.4844C18.6146 10.3837 18.6148 10.2847 18.6125 10.1876C18.611 10.1376 18.6091 10.0887 18.6064 10.0414C18.604 9.99661 18.6006 9.95366 18.5972 9.91059C18.5926 9.85516 18.5881 9.79838 18.5825 9.74928L18.4894 9.19422C18.4797 9.13135 18.4814 9.06725 18.4944 9.00497C18.4968 8.9926 18.5025 8.98194 18.5058 8.96981C18.5218 8.91045 18.5481 8.85432 18.5835 8.80399C18.5894 8.79543 18.59 8.78448 18.5965 8.77627C18.6012 8.7703 18.6088 8.76801 18.6138 8.76227C18.6588 8.70649 18.7148 8.66049 18.7782 8.62715L18.7829 8.62545L18.7854 8.62457C19.6152 8.30547 20.519 8.23053 21.3901 8.40848C21.7211 8.45377 22.0442 8.28338 22.194 7.98473C22.2953 7.78522 22.3049 7.55155 22.2204 7.34436C22.1368 7.13413 21.9658 6.97065 21.7522 6.89653C21.0493 6.62284 20.3069 6.46452 19.5536 6.42778C19.4583 6.42766 19.3633 6.42778 19.2687 6.42813L19.2677 6.42831C18.8997 6.42954 18.547 6.43803 18.2041 6.46663C18.1824 6.4685 18.1609 6.46961 18.1396 6.47161Z"
                        fill="currentColor"
                      />
                      <path
                        d="M6.69647 10.0803C7.26693 9.69615 7.95049 9.51615 8.63615 9.56953C8.86156 9.4725 9.10367 9.38232 9.37502 9.29437V3.75C9.37408 2.68717 9.09324 1.64332 8.56074 0.723516C8.30352 0.277969 7.82902 0.00251953 7.31457 0H5.21094C5.88242 0.943242 6.69647 2.32699 6.69647 3.75V10.0803Z"
                        fill="currentColor"
                      />
                      <path
                        d="M6.69629 26.2168V28.6607C6.69705 29.4001 7.29623 29.9993 8.03557 30C8.7749 29.9993 9.37408 29.4001 9.37484 28.6607V28.3607C8.37471 27.7915 7.47072 27.0679 6.69629 26.2168Z"
                        fill="currentColor"
                      />
                      <path
                        d="M22.125 14.457C21.9538 14.5968 21.7603 14.7067 21.5525 14.7821C21.5097 14.7987 21.4672 14.8157 21.424 14.8299C21.4029 14.8367 21.3818 14.8423 21.3606 14.8486C21.0748 14.9311 20.7803 14.9792 20.4831 14.9917C20.3793 15.3238 20.2188 15.8553 20.0593 16.4559C20.0641 16.4721 20.075 16.4847 20.0784 16.5015C20.0834 16.5251 20.5804 18.8568 22.362 19.3026C23.6246 19.618 24.2642 21.0583 24.3328 21.221C24.4478 21.4936 24.32 21.8078 24.0473 21.9228C23.7747 22.0378 23.4605 21.91 23.3455 21.6374C23.2147 21.3314 22.735 20.5 22.102 20.3415C21.0362 20.0428 20.1449 19.3099 19.646 18.3218C19.5906 18.6404 19.5596 18.9629 19.5534 19.2863C19.6233 19.9628 19.8745 20.6079 20.2806 21.1535C20.724 21.7893 21.0187 22.5168 21.1432 23.2819C21.9896 23.8585 22.7061 24.6056 23.2469 25.4753C23.5692 26.1198 23.8454 26.2375 23.8896 26.2527C24.1744 26.2797 24.3878 26.5257 24.3743 26.8115C24.3608 27.0972 24.1252 27.322 23.8392 27.3221C23.5483 27.2998 23.2734 27.1803 23.0588 26.9826C22.9601 27.2501 22.8076 27.4945 22.6108 27.7008C22.4759 27.8381 22.2776 27.8926 22.0915 27.8433C21.9054 27.794 21.7601 27.6487 21.7108 27.4626C21.6615 27.2765 21.716 27.0782 21.8533 26.9433C22.0856 26.6251 22.2152 26.2435 22.225 25.8496C21.9077 25.3658 21.5149 24.9361 21.0616 24.5767C20.846 25.4973 20.4587 26.3689 19.9197 27.1457C19.4101 27.8094 19.098 28.6033 19.0195 29.4363C19.2432 29.4879 19.4625 29.5399 19.6744 29.591C20.5073 29.8301 21.3662 29.9676 22.2321 30.0006C23.4325 30.0006 25.4464 29.3048 25.4464 24.6434C25.4463 22.2291 24.2856 17.9544 22.125 14.457Z"
                        fill="currentColor"
                      />
                      <path
                        d="M19.3621 21.7052C19.2353 21.4941 19.1047 21.2729 18.9828 21.0421C18.6411 21.5883 18.0541 21.933 17.4107 21.9652C17.1148 21.9652 16.875 21.7254 16.875 21.4295C16.875 21.1336 17.1148 20.8938 17.4107 20.8938C17.976 20.8938 18.4159 19.9286 18.5071 19.6593C18.4909 19.5357 18.4825 19.4112 18.4821 19.2867C18.6078 17.8055 18.9089 16.3445 19.3791 14.9344C19.3486 14.9287 19.3178 14.9237 19.2878 14.9173C19.2287 14.9047 19.1731 14.8879 19.1161 14.8725C19.0523 14.8553 18.9881 14.8388 18.9271 14.8182C18.8671 14.798 18.8108 14.7744 18.7537 14.7512C18.7011 14.7296 18.6485 14.7084 18.5984 14.6844C18.5408 14.6566 18.4867 14.6262 18.4327 14.5952C18.3893 14.5703 18.3465 14.5451 18.3057 14.518C18.2525 14.4829 18.2027 14.4458 18.1542 14.4072C18.1192 14.3795 18.0857 14.3512 18.0533 14.3218C18.007 14.2799 17.9627 14.2358 17.9209 14.1895C17.894 14.1597 17.8692 14.1288 17.8447 14.0976C17.8059 14.0488 17.7699 13.9979 17.7369 13.945C17.7299 13.9335 17.7202 13.9234 17.7134 13.9117C17.7028 13.8933 17.6981 13.8738 17.6883 13.8553C17.667 13.8147 17.6404 13.7766 17.6229 13.7344C17.6098 13.7027 17.6027 13.6703 17.592 13.6384C17.5873 13.6245 17.5828 13.6106 17.5785 13.5965C17.5502 13.5049 17.5314 13.4106 17.5225 13.3151L17.5219 13.3122C17.4789 13.3166 17.4314 13.3181 17.3878 13.3221C17.2071 13.3388 17.0218 13.3525 16.8319 13.3631C16.7555 13.3673 16.68 13.3721 16.6021 13.3754C16.3427 13.3864 16.0781 13.3938 15.8036 13.3938C15.6493 13.3927 15.4952 13.3835 15.342 13.3662C15.2356 13.3552 15.1252 13.3366 15.0147 13.3189C14.9596 13.31 14.9068 13.3036 14.8507 13.2931C14.7249 13.2697 14.5991 13.2407 14.4718 13.2101C14.4236 13.1985 14.3763 13.1882 14.3279 13.1757C14.2088 13.1446 14.0928 13.11 13.9756 13.0736C13.9123 13.0539 13.8499 13.0348 13.7874 13.0137C13.7449 12.9992 13.7003 12.9877 13.6584 12.9727C13.656 13.0301 13.6443 13.0877 13.6386 13.1452C13.6317 13.2156 13.6265 13.2859 13.6146 13.3564C13.6016 13.4331 13.582 13.5099 13.5635 13.5867C13.5465 13.6569 13.5315 13.727 13.5101 13.7971C13.4867 13.8741 13.4571 13.951 13.4286 14.0279C13.4027 14.0977 13.3788 14.1674 13.3489 14.237C13.3157 14.3143 13.2769 14.3913 13.2391 14.4684C13.2055 14.5371 13.1738 14.6059 13.1367 14.6744C13.0945 14.7523 13.047 14.8297 13.0005 14.9072C12.9603 14.9744 12.922 15.0417 12.8789 15.1085C12.8285 15.1866 12.7733 15.264 12.7192 15.3416C12.6755 15.4042 12.6341 15.4671 12.5882 15.5293L12.5893 15.5351C12.5842 15.9746 12.7166 16.4047 12.9681 16.7651L12.969 16.7662C13.3183 17.1479 13.7383 17.4582 14.2056 17.6801C14.3472 17.6802 14.4828 17.7367 14.5825 17.8372C14.6823 17.9376 14.7378 18.0737 14.7369 18.2152C14.7347 18.5121 14.4933 18.7514 14.1965 18.7509C14.0087 18.7432 13.8245 18.6963 13.6559 18.6132C13.6592 18.6782 13.6607 18.7305 13.6607 18.7509C13.6607 19.0468 13.4209 19.2867 13.125 19.2867C12.8291 19.2867 12.5893 19.0468 12.5893 18.7509C12.5942 18.312 12.4618 17.8825 12.2105 17.5225C11.9638 17.2605 11.7837 16.9431 11.6855 16.5969L11.6726 16.6106C11.6179 16.6687 11.5643 16.7273 11.5084 16.7848C11.4322 16.8631 11.354 16.9399 11.2761 17.017C11.2204 17.0722 11.1658 17.128 11.1094 17.1825C11.0274 17.2618 10.9441 17.3392 10.8609 17.417C10.8071 17.4674 10.754 17.5187 10.6998 17.5685C10.612 17.6491 10.5239 17.7275 10.4357 17.8063C10.3852 17.8516 10.3349 17.8978 10.2843 17.9424C10.1837 18.0311 10.0836 18.1173 9.98345 18.2035L9.94331 18.2383C10.1825 19.0485 10.3408 19.8803 10.4159 20.7217C10.4176 20.7269 10.4214 20.731 10.423 20.7362C10.7774 20.8468 11.1472 20.9 11.5184 20.8937C11.8143 20.8939 12.054 21.1338 12.0539 21.4297C12.0537 21.7255 11.8137 21.9653 11.5179 21.9651C11.1706 21.9683 10.8238 21.9367 10.4828 21.8706C10.5375 22.3697 10.8107 22.8188 11.2289 23.0967C11.4461 23.2121 11.557 23.4605 11.498 23.6993C11.439 23.9381 11.2253 24.1063 10.9793 24.1074C10.8971 24.1075 10.8161 24.0883 10.7426 24.0514C9.8331 23.5012 9.30581 22.4902 9.37507 21.4294C9.35896 20.6078 9.24605 19.791 9.03868 18.9958C8.91739 19.0954 8.79821 19.1929 8.68296 19.287C8.21995 19.6652 7.82028 19.9917 7.61099 20.201C7.52567 20.2877 7.45132 20.3846 7.38968 20.4895C7.20563 20.8409 7.06876 21.2149 6.98269 21.6021C6.94366 21.7454 6.89942 21.8983 6.85056 22.0525L6.83802 22.0913C6.81622 22.1583 6.79343 22.2243 6.76829 22.2911C6.74989 22.3401 6.72903 22.3879 6.70858 22.436C6.68222 22.4978 6.65415 22.5582 6.62362 22.6181C6.59146 22.6814 6.55735 22.7433 6.5198 22.803C6.49782 22.838 6.47374 22.8711 6.44972 22.9046C6.41374 22.9542 6.37513 23.0019 6.33417 23.0474C6.30534 23.08 6.27733 23.1128 6.24575 23.1431C6.18757 23.1979 6.12499 23.2479 6.05872 23.2925C6.04829 23.2997 6.04021 23.3089 6.02954 23.3159C6.22554 23.7258 6.45347 24.1196 6.71134 24.4937C6.86315 24.7187 7.02511 24.9364 7.19714 25.1469C7.25843 25.2216 7.31942 25.2967 7.38241 25.3686C7.4723 25.4721 7.56481 25.5736 7.65997 25.6731C7.74587 25.7626 7.83388 25.8479 7.92212 25.9328C8.0519 26.0582 8.18597 26.1803 8.32425 26.2991C8.43423 26.3933 8.54415 26.4872 8.65653 26.5752C8.75151 26.6497 8.84995 26.7214 8.94851 26.7929C9.03856 26.8587 9.12915 26.9224 9.22026 26.9842C9.33171 27.0598 9.44397 27.1347 9.55964 27.2067C9.61952 27.2441 9.67946 27.2787 9.73952 27.3146C9.87921 27.398 10.0192 27.481 10.1648 27.5593C11.2526 28.1434 12.4219 28.5612 13.6336 28.7987C13.6385 28.7995 13.6422 28.8033 13.647 28.8044C14.0045 28.8772 14.3676 28.9191 14.7323 28.9294C15.815 28.9253 16.8958 29.0215 17.9608 29.2167C18.0818 28.2643 18.4423 27.3582 19.0086 26.5831C19.6648 25.7118 20.0416 24.6621 20.0894 23.5723C20.0193 22.8959 19.7681 22.2508 19.3621 21.7052Z"
                        fill="currentColor"
                      />
                      <path
                        d="M11.7857 29.9991C12.1042 30 12.4122 29.886 12.6533 29.6778C11.9055 29.4863 11.1756 29.2308 10.4717 28.9141C10.5939 29.5434 11.1446 29.9982 11.7857 29.9991Z"
                        fill="currentColor"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_11_4992">
                        <rect width="30" height="30" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div
                  class="icc__body-tabs-item"
                  @click="setActiveBody(6)"
                  :class="{ 'icc__body-tabs-item_active': activeBody == 6 }"
                >
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_11_5007)">
                      <path
                        d="M28.4426 15.0921C27.8247 13.516 27.0302 12.0207 26.0753 10.637C23.4629 6.51152 18.4246 4.62779 17.3845 11.9652L17.9844 12.9906L18.941 14.0386L20.5192 15.1818L21.5191 13.5623L21.4056 11.6008C21.4 11.4906 21.4366 11.3825 21.5075 11.3002C21.5785 11.2179 21.6779 11.1679 21.7841 11.1613C21.8904 11.1546 21.9949 11.1918 22.0749 11.2647C22.1548 11.3376 22.2037 11.4403 22.2109 11.5504L22.3137 13.2764L23.908 13.4054C24.0132 13.4157 24.1103 13.4684 24.1784 13.5521C24.2466 13.6358 24.2804 13.7438 24.2726 13.8531C24.2648 13.9623 24.216 14.064 24.1368 14.1364C24.0575 14.2088 23.954 14.2461 23.8485 14.2404L22.1407 14.1059L21.184 15.6693L23.2216 17.1488L25.67 17.754C25.7735 17.7812 25.8624 17.8496 25.9176 17.9442C25.9728 18.0389 25.9898 18.1523 25.9649 18.2599C25.94 18.3675 25.8753 18.4606 25.7847 18.5191C25.6941 18.5775 25.5849 18.5966 25.4808 18.5722L23.5622 18.0959L24.0216 20.7017L26.5888 22.1868C26.6802 22.2424 26.7469 22.3329 26.7747 22.4389C26.8025 22.5448 26.7892 22.6579 26.7377 22.7538C26.6861 22.8498 26.6004 22.921 26.4988 22.9522C26.3973 22.9834 26.2879 22.9722 26.1943 22.9209L23.4595 21.3406C23.4065 21.3109 23.3605 21.2694 23.325 21.219C23.2895 21.1685 23.2652 21.1105 23.2541 21.0492L22.6812 17.7821C21.6225 17.0169 19.4972 15.4623 18.4438 14.7055C18.3432 14.6125 17.3362 13.5379 17.2871 13.4166C17.2619 13.3257 15.8948 11.169 15.9954 11.1021V7.57715H14.0011V11.1021C14.0005 11.1791 13.98 11.2546 13.9416 11.3206L12.6877 13.467C12.6715 13.4894 11.6176 14.6494 11.6176 14.6494C11.596 14.6663 7.31538 17.7821 7.31538 17.7821L6.74242 21.0492C6.73127 21.1106 6.70705 21.1686 6.67152 21.219C6.63599 21.2694 6.59006 21.311 6.53707 21.3406L3.80766 22.921C3.714 22.9725 3.60465 22.9841 3.50289 22.9532C3.40112 22.9224 3.315 22.8516 3.26285 22.7558C3.21071 22.6601 3.19667 22.5471 3.22373 22.4408C3.25079 22.3345 3.31681 22.2434 3.40771 22.1868L5.97497 20.7018L6.43438 18.0959L4.51566 18.5722C4.46374 18.5854 4.40981 18.5879 4.35697 18.5794C4.30413 18.5709 4.25343 18.5517 4.20778 18.5229C4.16213 18.494 4.12243 18.4561 4.09096 18.4113C4.05949 18.3665 4.03688 18.3156 4.02441 18.2617C4.01195 18.2078 4.00988 18.1519 4.01834 18.0972C4.02679 18.0424 4.04559 17.99 4.07366 17.9428C4.10173 17.8956 4.13852 17.8546 4.18191 17.8222C4.2253 17.7899 4.27444 17.7667 4.32649 17.754L6.77487 17.1488L8.81246 15.6638L7.85583 14.1059L6.14791 14.2404C6.04272 14.2456 5.93973 14.208 5.86089 14.1356C5.78205 14.0632 5.73359 13.9618 5.72584 13.8529C5.71809 13.744 5.75167 13.6363 5.81942 13.5527C5.88716 13.4691 5.98372 13.4162 6.0885 13.4054L7.68288 13.2764L7.78556 11.5504C7.79272 11.4402 7.84161 11.3374 7.92157 11.2645C8.00154 11.1915 8.10608 11.1543 8.21239 11.161C8.3187 11.1677 8.41816 11.2176 8.48907 11.3001C8.55997 11.3825 8.59657 11.4906 8.59088 11.6009L8.47736 13.5623L9.48263 15.1818L11.0554 14.0386L12.0121 12.9906L12.6228 11.9539C11.5485 4.69 6.53739 6.48078 3.92116 10.6371C1.30312 14.469 -0.0694067 19.0661 0.00270263 23.7616L0.00267045 27.4546C0.0621489 28.1823 0.395396 28.8565 0.930394 29.3315C1.46539 29.8065 2.15917 30.0442 2.86181 29.9932C3.76398 29.9198 4.62688 29.5794 5.34801 29.0125C5.79087 28.6634 6.33804 28.4868 6.89378 28.5138C8.70705 28.7642 11.0186 29.3409 12.0445 27.3704C12.5807 26.2491 12.8705 25.0185 12.8931 23.7672C12.8931 23.7672 13.1363 17.5467 13.093 16.8238L9.09352 20.0965L10.6393 21.8114C10.7099 21.8884 10.7487 21.9909 10.7474 22.0971V24.165C10.7456 24.2753 10.7021 24.3804 10.6263 24.4577C10.5505 24.535 10.4484 24.5784 10.342 24.5784C10.2357 24.5784 10.1336 24.535 10.0577 24.4577C9.98192 24.3804 9.93844 24.2752 9.93667 24.165V22.2597L8.65575 20.8362L7.69367 23.5766C7.65687 23.68 7.58223 23.7643 7.48594 23.8111C7.38964 23.8579 7.27944 23.8635 7.17921 23.8266C7.07898 23.7897 6.99679 23.7134 6.95044 23.6142C6.9041 23.5149 6.89733 23.4008 6.93161 23.2964L8.09362 19.9676C8.12038 19.8528 8.18795 19.7528 8.28281 19.6874L14.7469 14.3972C14.818 14.3374 14.9067 14.3048 14.9983 14.3048C15.0898 14.3048 15.1785 14.3374 15.2496 14.3972C16.7188 15.6033 20.2071 18.451 21.7137 19.6874C21.7603 19.7183 21.8006 19.7585 21.8321 19.8056C21.8636 19.8528 21.8859 19.9059 21.8975 19.962L23.0649 23.2964C23.0988 23.4007 23.0918 23.5146 23.0454 23.6136C22.999 23.7126 22.9169 23.7887 22.8168 23.8255C22.7168 23.8622 22.6068 23.8567 22.5106 23.8102C22.4145 23.7636 22.3398 23.6797 22.3028 23.5765L21.3408 20.8362L20.0598 22.2597V24.165C20.0576 24.275 20.0139 24.3797 19.9381 24.4566C19.8624 24.5336 19.7605 24.5767 19.6544 24.5767C19.5484 24.5767 19.4465 24.5336 19.3708 24.4566C19.295 24.3796 19.2513 24.275 19.2491 24.165V22.0971C19.2478 21.9909 19.2866 21.8884 19.3572 21.8114L20.903 20.0965L16.9089 16.8238C16.8656 17.5467 17.1034 23.7447 17.1034 23.7447C17.1231 25.0037 17.413 26.2422 17.952 27.3705C18.8515 29.0945 20.8339 28.9053 22.5028 28.5865C22.8702 28.4831 23.2555 28.4683 23.6293 28.5431C24.0031 28.6179 24.3554 28.7804 24.6593 29.0181C26.5353 30.5767 29.6722 30.3546 29.9992 27.4209V23.8288C30.0231 20.8402 29.4947 17.8746 28.4426 15.0921Z"
                        fill="currentColor"
                      />
                      <path d="M14 0H16V2H14V0Z" fill="currentColor" />
                      <path d="M14 3H16V4H14V3Z" fill="currentColor" />
                      <path d="M14 5H16V7H14V5Z" fill="currentColor" />
                    </g>
                    <defs>
                      <clipPath id="clip0_11_5007">
                        <rect width="30" height="30" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div
                  class="icc__body-tabs-item"
                  @click="setActiveBody(7)"
                  :class="{ 'icc__body-tabs-item_active': activeBody == 7 }"
                >
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.20568 1.07955C7.98516 1.20603 7.92132 1.33933 7.81179 1.90216C7.27656 4.65342 7.619 7.2991 8.83517 9.80753C9.75504 11.7049 11.1584 13.4125 13.006 14.8825C14.0765 15.7342 14.6103 16.7036 14.6194 17.8126C14.6259 18.6127 14.3585 19.0783 13.741 19.3422C12.9035 19.7003 11.8822 19.5759 10.03 18.8901C8.72276 18.4062 7.94691 18.2602 6.89942 18.3012C5.55136 18.3538 4.53227 18.7213 3.42952 19.5522C1.84847 20.7436 0.705328 22.7005 0.200106 25.0807C0.0968776 25.5672 0.0474406 26.1026 0.0196407 27.0361C-0.0186763 28.3216 -0.0186764 28.3216 0.186306 28.5266C0.391289 28.7316 0.391289 28.7316 2.23546 28.7316C3.44453 28.7316 4.13584 28.706 4.24289 28.6572C4.46924 28.5541 4.53616 28.3863 4.62063 27.7099C4.91491 25.3537 6.1996 24.7002 8.05241 25.9642C8.35775 26.1726 8.89083 26.5357 9.23696 26.771C13.2848 29.5236 19.028 29.3274 23.5882 26.2806C24.5381 25.646 25.1847 25.1024 26.0627 24.2005C28.3145 21.8874 29.6434 19.0504 29.9492 15.9042C30.0507 14.8591 29.9908 11.7298 29.8516 10.8117C29.5975 9.1345 29.2662 8.01929 28.6378 6.72609C27.1667 3.69878 24.8629 1.77308 21.9717 1.15404C21.137 0.975321 19.9571 0.989992 19.2587 1.18774C17.7077 1.62678 16.3446 2.69637 15.7168 3.96673C15.4557 4.49526 15.3266 5.02152 15.2045 6.05487C15.1155 6.80842 14.9235 7.39664 14.7334 7.49832C14.4762 7.63605 13.8532 7.36629 13.5695 6.99444C13.0758 6.34707 12.9552 5.41393 13.07 3.12804C13.1605 1.3254 13.1439 1.1858 12.8243 1.06428C12.5703 0.967685 8.37657 0.981551 8.20568 1.07955ZM18.8418 6.16721C18.9712 6.34124 18.9716 6.3604 18.8609 7.02218C18.5451 8.9107 17.7179 10.1948 16.3978 10.8454C16.0431 11.0202 15.6862 11.1452 15.4874 11.1644C15.19 11.1929 15.1469 11.1785 15.0104 11.0051C14.901 10.8659 14.871 10.7616 14.8996 10.6188C14.9561 10.3365 15.0359 10.2667 15.4519 10.1359C15.8822 10.0005 16.4854 9.62318 16.7925 9.29715C17.3291 8.72762 17.6727 7.91693 17.8524 6.79696C17.9276 6.32805 17.9831 6.16279 18.0966 6.06961C18.3101 5.89437 18.6744 5.94213 18.8418 6.16721ZM26.0639 18.8087C26.3346 19.0279 26.274 19.3158 25.7866 20.1251C24.5693 22.1465 22.8715 23.7206 20.7676 24.7784C20.1477 25.0901 19.9515 25.1098 19.7246 24.8828C19.3927 24.551 19.5494 24.2212 20.1788 23.9263C22.1002 23.026 23.9203 21.3154 25.0258 19.371C25.1885 19.0849 25.3724 18.8132 25.4346 18.7671C25.5988 18.6456 25.8858 18.6645 26.0639 18.8087Z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
                <div
                  class="icc__body-tabs-item"
                  @click="setActiveBody(8)"
                  :class="{ 'icc__body-tabs-item_active': activeBody == 8 }"
                >
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M3.66609 1.07705C3.23897 1.19829 3.0799 1.27285 2.66311 1.54717C1.46444 2.33625 0.55426 3.93759 0.132478 5.99952C0.0139732 6.57861 -0.00199181 6.82335 0.000179903 8.02402C0.00246901 9.27955 0.0153819 9.44891 0.160182 10.1222C0.668715 12.4874 1.82307 14.1954 3.32519 14.8052C3.8241 15.0078 4.6109 15.0555 5.10511 14.9133C6.19983 14.5981 7.12856 13.746 7.79933 12.441C8.09773 11.8604 8.42038 11.0366 8.42038 10.8551C8.42038 10.7254 8.00681 10.6399 7.12698 10.5879C6.3991 10.5448 6.29815 10.5247 5.92373 10.3478C5.38937 10.0952 4.92398 9.6357 4.65921 9.09921C4.46463 8.70493 4.45847 8.67088 4.45847 7.99496C4.45847 7.32886 4.46686 7.28056 4.64541 6.91976C4.88677 6.43209 5.19245 6.08286 5.614 5.81301C6.14395 5.47389 6.53187 5.39625 7.58404 5.41868C8.39361 5.43594 8.47925 5.42833 8.47913 5.33935C8.47896 5.12326 8.09756 4.12415 7.79146 3.53796C7.10015 2.21391 6.15475 1.35224 5.09279 1.07839C4.68967 0.974415 4.02982 0.973776 3.66609 1.07705ZM24.7963 1.09803C23.7217 1.45279 22.8656 2.25651 22.1973 3.53796C21.8802 4.14606 21.5093 5.11135 21.5094 5.32842C21.5094 5.43129 21.5707 5.4378 22.5512 5.43827C23.4931 5.43879 23.624 5.45128 23.9158 5.56863C24.5662 5.83016 25.1326 6.39077 25.3983 7.036C25.5084 7.30323 25.53 7.46526 25.53 8.02402C25.53 8.66686 25.5223 8.7079 25.3292 9.09921C25.0644 9.6357 24.5991 10.0952 24.0647 10.3478C23.6903 10.5247 23.5893 10.5448 22.8614 10.5879C21.9816 10.6399 21.568 10.7254 21.568 10.8551C21.568 11.0366 21.8907 11.8604 22.1891 12.441C22.8634 13.7529 23.7828 14.5965 24.8833 14.9133C25.3775 15.0555 26.1643 15.0078 26.6632 14.8052C28.1909 14.185 29.361 12.42 29.8552 9.9904C30.0366 9.0984 30.0503 7.03995 29.8808 6.13516C29.4893 4.04476 28.5649 2.38065 27.3334 1.54927C26.7743 1.17184 26.3526 1.03486 25.6767 1.01109C25.2514 0.996151 25.0425 1.01678 24.7963 1.09803ZM6.68888 7.18554C6.12112 7.47793 5.96447 8.09847 6.3454 8.54668C6.58141 8.82442 6.69522 8.85831 7.53996 8.90248C8.39044 8.94688 8.87967 9.06271 9.4773 9.36109C10.2918 9.7678 11.0035 10.4839 11.4106 11.3062C11.7943 12.0814 11.8373 12.3126 11.8644 13.7487C11.8886 15.0273 11.8886 15.0273 11.5917 15.2239C11.1488 15.5174 10.3643 16.3696 10.0567 16.8916C9.45858 17.9067 9.27703 18.5872 9.27492 19.8221C9.27322 20.8571 9.37787 21.36 9.76555 22.1795C10.0647 22.8119 10.2929 23.1351 11.0418 23.9871C11.3917 24.3851 11.7241 24.7939 11.7807 24.8954C11.8716 25.0588 11.8834 25.2662 11.8834 26.7003C11.8834 28.243 11.8893 28.3311 12.0077 28.5396C12.2542 28.9739 12.8462 29.1353 13.2339 28.874C13.6734 28.5779 13.6715 28.5859 13.6919 26.9059C13.7102 25.3965 13.7102 25.3965 14.0734 25.4425C14.2731 25.4679 14.6875 25.4886 14.9942 25.4886C15.3009 25.4886 15.7153 25.4679 15.915 25.4425C16.2782 25.3965 16.2782 25.3965 16.2965 26.9059C16.3169 28.5859 16.315 28.5779 16.7545 28.874C17.1422 29.1353 17.7343 28.9739 17.9807 28.5396C18.0991 28.3311 18.105 28.243 18.105 26.7003C18.105 25.2662 18.1168 25.0588 18.2078 24.8954C18.2642 24.7939 18.5967 24.3851 18.9466 23.9871C19.696 23.1345 19.9241 22.8114 20.2225 22.1795C20.6069 21.3653 20.7124 20.8576 20.7122 19.8221C20.7119 18.5881 20.5309 17.9085 19.9317 16.8916C19.6241 16.3696 18.8397 15.5174 18.3967 15.2239C18.0998 15.0273 18.0998 15.0273 18.124 13.7487C18.1505 12.3478 18.1923 12.1094 18.5417 11.3658C19.051 10.2822 20.0386 9.44379 21.2452 9.07085C21.5354 8.98117 21.8927 8.93194 22.4616 8.90329C23.1385 8.86918 23.2924 8.84389 23.4264 8.74486C23.9694 8.34344 23.9905 7.68245 23.4726 7.29132C23.2854 7.14991 23.186 7.1212 22.8202 7.10295C21.87 7.05541 20.6512 7.30864 19.7993 7.73052C19.1273 8.06336 18.656 8.39917 18.1298 8.92026C16.8709 10.1667 16.2877 11.6713 16.286 13.6767C16.2855 14.2441 16.2855 14.2441 16.036 14.1998C15.8989 14.1755 15.43 14.1555 14.9942 14.1555C14.5584 14.1555 14.0896 14.1755 13.9524 14.1998C13.7029 14.2441 13.7029 14.2441 13.7025 13.6767C13.7014 12.4533 13.5203 11.5613 13.0903 10.6613C12.7427 9.93367 12.4166 9.47268 11.8587 8.92026C10.6506 7.72407 9.07741 7.09302 7.3067 7.09447C7.02144 7.0947 6.80257 7.12696 6.68888 7.18554Z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
              </div>
              <div class="icc__body-tabs-body mt-8 mt-md-8 mt-xs-0">
                <div v-if="activeBody == 0">
                  <div class="title-1 mb-4">Температура</div>
                  <div class="text-1">T = 36,6С.</div>
                </div>
                <div v-if="activeBody == 1">
                  <div class="title-1 mb-4">ИМТ</div>
                  <div class="text-1">32 кг/см&#178; (ожирение 1 ст.).</div>
                </div>
                <div v-if="activeBody == 2">
                  <div class="title-1 mb-4">Нервная система</div>
                  <div class="text-1">
                    Сознание ясное, явного неврологического дефицита не
                    выявлено, гемодинамика стабильная. В психическом статусе:
                    ориентирована всесторонне верно, в беседе напряжена,
                    тревожна.
                  </div>
                </div>
                <div v-if="activeBody == 3">
                  <div class="title-1 mb-4">Кожа</div>
                  <div class="text-1">
                    Кожный покров обычной окраски, высыпаний нет. У верхнего
                    века правого глаза ксантелазма. Видимые слизистые без
                    особенностей. Отеков нет.
                  </div>
                </div>
                <div v-if="activeBody == 4">
                  <div class="title-1 mb-4">Опорно-двигательная система</div>
                  <div class="text-1">
                    Мышцы и суставы без особенностей. При пальпации остистых
                    отростков позвонков болезненности нет.
                  </div>
                </div>
                <div v-if="activeBody == 5">
                  <div class="title-1 mb-4">Сердечно-сосудистая система</div>
                  <div class="text-1">
                    АД 125/70 мм рт.ст. на обеих руках.
                    <br />Лодыжечно-плечевой индекс = 1,1. <br />Частота
                    сердечных сокращений 72 уд/мин. Пульс = 72 уд/мин. Дефицита
                    пульса нет. <br />Верхушечный толчок определяется в 5
                    межреберье на 1,5 см кнутри от среднеключичной линии.
                    Сосудистый пучок не выходит за нормальные границы при
                    перкуссии, абсолютная и относительная границы сердца в
                    пределах нормы. Тоны сердца приглушены, ритмичные. Шумов
                    нет. Соотношение тонов во всех точках сохранено.
                  </div>
                </div>
                <div v-if="activeBody == 6">
                  <div class="title-1 mb-4">Дыхательная система</div>
                  <div class="text-1">
                    Грудная клетка без особенностей. ЧДД 16/мин. Сатурация 99%
                    на атмосферном воздухе. Дыхание везикулярное, хрипов нет.
                    При перкуссии грудной клетки ясный легочный звук.
                  </div>
                </div>
                <div v-if="activeBody == 7">
                  <div class="title-1 mb-4">Желудочно-кишечный тракт</div>
                  <div class="text-1">
                    Живот обычной формы, увеличен за счет подкожно-жировой
                    клетчатки, при пальпации мягкий, безболезненный. Печень не
                    выступает из-под края реберной дуги, размеры по Курлову
                    9*8*7 см. Селезенка не пальпируется. Стул, со слов,
                    оформленный, тип 3-4 по бристольской шкале формы кала,
                    регулярный, 1 раз в сутки.
                  </div>
                </div>
                <div v-if="activeBody == 8">
                  <div class="title-1 mb-4">Мочевыделительная система</div>
                  <div class="text-1">
                    Поколачивание по поясничной области безболезненное.
                    Мочеиспускание свободное, безболезненное (со слов).
                  </div>
                </div>
                <div class="icc__block-body-img d-md-none">
                  <img
                    :class="{ _active: activeBody == i - 1 }"
                    v-for="i in 9"
                    :key="i"
                    :src="
                      `https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/body${i}.png`
                    "
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="icc__block-body-img d-none d-md-block">
            <img
              :class="{ _active: activeBody == i - 1 }"
              v-for="i in 9"
              :key="i"
              :src="
                `https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/body${i}.png`
              "
            />
          </div>
        </div>
      </div>

      <div class="icc__tabs">
        <div class="icc__tabs-tip d-xl-none">
          <img
            class="mr-2"
            :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/tap.svg`"
          />
          Выберите следующее действие на вкладках ниже
        </div>
        <div class="icc__tabs-row">
          <div
            class="icc__tab"
            @click="setActiveTab(0)"
            :class="{ icc__tab_active: activeTab == 0 }"
          >
            Продолжить сбор жалоб
          </div>
          <div
            class="icc__tab"
            @click="setActiveTab(1)"
            :class="{ icc__tab_active: activeTab == 1 }"
          >
            Уточнить анамнез заболевания
          </div>
          <div
            class="icc__tab"
            @click="setActiveTab(2)"
            :class="{ icc__tab_active: activeTab == 2 }"
          >
            Уточнить анамнез жизни
          </div>
          <div
            class="icc__tab"
            @click="setActiveTab(3)"
            :class="{ icc__tab_active: activeTab == 3 }"
          >
            Перейти к физикальному осмотру
          </div>
        </div>
      </div>
    </div>
    <div class="icc__block-steps">
      <Steps
        @refreshClinicalCase="$emit('refreshClinicalCase')"
        @prevStep="prevStep"
        @nextStep="nextStep"
        :stepsCount="18"
        :activeStep="3"
      />
    </div>
  </div>
</template>

<script>
import Steps from "@/components/interactiveClinicalCase/Steps.vue";
import RadioButton from "@/components/interactiveClinicalCase/RadioButton.vue";
export default {
  name: "ICCStep2",
  components: {
    Steps,
    RadioButton,
  },
  props: {
    activeTabParent: Number,
    step: Object,
    visible: Boolean,
  },
  data: () => ({
    radioTabs: [null, null, null],
    activeTab: 0,
    activeBody: 0,
    tabsNames: [
      "Продолжить сбор жалоб",
      "Уточнить анамнез заболевания",
      "Уточнить анамнез жизни",
      "Перейти к физикальному осмотру",
    ],
    radiosNames: [
      [
        "Расскажите, как ощущаете дискомфорт и боль в груди?",
        "Раньше подобный дискомфорт в груди беспокоил?",
        "Беспокоит ли одышка и в каких ситуациях?",
        "Что-то еще беспокоит?",
      ],
      [
        "Как давно Вам известно о повышении АД и аритмии?",
        "Отмели ли Вы ухудшение Вашего самочувствия за последний год?",
        "Нарушения ритма начинается внезапно?",
        "В момент аритмии беспокоит что-либо еще?",
      ],
      [
        "Хронические заболевания",
        "Лекарственный и аллергический анамнез",
        "Наследственность",
        "Гинекологический анамнез",
        "Образ жизни",
      ],
    ],
    activeBodyNames: [
      "Температура",
      "ИМТ",
      "Нервная система",
      "Кожа",
      "Опорно-двигательная система",
      "Сердечно-сосудистая система",
      "Дыхательная система",
      "Желудочно-кишечный тракт",
      "Мочевыделительная система",
    ],
  }),
  computed: {
    lastViewedTab() {
      return this.step.tabs.filter((tab) => tab.is_viewed).pop();
    },
  },
  methods: {
    prevStep() {
      if (this.activeTab > 0) {
        this.setActiveTab(this.activeTab - 1);
      } else {
        this.$emit("prevStep");
        this.$emit("clearActiveTab");
      }
    },
    nextStep() {
      if (this.activeTab < 3) {
        this.setActiveTab(this.activeTab + 1);
      } else {
        this.$emit("nextStep");
      }
    },
    setActiveBody(ind) {
      this.activeBody = ind;
    },
    setActiveTab(ind, noRequest, from2step) {
      this.activeTab = ind;
      const vm = this;
      if (!this.step.tabs[ind].is_viewed && !noRequest) {
        let params = new URLSearchParams();
        if (this.$route.query.access) {
          params.append("access", this.$route.query.access);
        }
        this.$axios({
          url: `/api/clinical-case/user-progress`,
          method: "POST",
          params: params,
          data: {
            step: this.step.slug,
            tab: this.step.tabs[ind].slug,
          },
        })
          .then((res) => {})
          .catch((error) => {});
      }
      this.$nextTick(() => {
        this.$el
          .querySelector(".icc__tabs-row")
          .scrollTo(
            this.$el.querySelector(".icc__tab_active").offsetLeft - 76,
            0
          );
        if (!noRequest && !from2step) {
          if (typeof ym !== "undefined") {
            ym(91468266, "reachGoal", "clinical case", {
              "Клинический случай": {
                "Экран 3 - Сбор жалоб": {
                  "Показ вкладок": {
                    [`${vm.tabsNames[vm.activeTab]}`]: {
                      Params: {
                        ...vm.$root.ymFields,
                      },
                    },
                  },
                },
              },
            });
          }
        }
      });
    },
  },
  mounted() {
    const vm = this;
    if (this.lastViewedTab) {
      this.setActiveTab(this.lastViewedTab.internal_number, true);
    } else {
      this.setActiveTab(0, true);
    }
  },
  watch: {
    activeTabParent: {
      handler(n, o) {
        const vm = this;
        if (typeof o != "undefined") {
          this.setActiveTab(this.activeTabParent, false, true);
        }
      },
      deep: true,
      immediate: true,
    },
    radioTabs: {
      handler(n, o) {
        if (o) {
          const vm = this;
          let stamps = {
            50: false,
            80: false,
          };
          this.$nextTick(() => {
            this.$el.querySelectorAll("video").forEach((v, i) => {
              v.onplay = function () {
                if (this.currentTime == 0) {
                  if (typeof ym !== "undefined") {
                    ym(91468266, "reachGoal", "clinical case", {
                      "Клинический случай": {
                        Видео: {
                          "Экран 3": {
                            [`${vm.tabsNames[vm.activeTab]}`]: {
                              [`${
                                vm.radiosNames[vm.activeTab][
                                  vm.radioTabs[vm.activeTab]
                                ]
                              }`]: {
                                "Начало просмотра": {
                                  Params: {
                                    ...vm.$root.ymFields,
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                    });
                  }
                }
              };
              v.ontimeupdate = function () {
                let percent = Math.ceil(
                  (this.currentTime / this.duration) * 100
                );
                if (percent >= 50 && !stamps[50]) {
                  if (typeof ym !== "undefined") {
                    ym(91468266, "reachGoal", "clinical case", {
                      "Клинический случай": {
                        Видео: {
                          "Экран 3": {
                            [`${vm.tabsNames[vm.activeTab]}`]: {
                              [`${
                                vm.radiosNames[vm.activeTab][
                                  vm.radioTabs[vm.activeTab]
                                ]
                              }`]: {
                                "Просмотр видео на 50%": {
                                  Params: {
                                    ...vm.$root.ymFields,
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                    });
                    stamps[50] = true;
                  }
                }
                if (percent >= 80 && !stamps[80]) {
                  if (typeof ym !== "undefined") {
                    ym(91468266, "reachGoal", "clinical case", {
                      "Клинический случай": {
                        Видео: {
                          "Экран 3": {
                            [`${vm.tabsNames[vm.activeTab]}`]: {
                              [`${
                                vm.radiosNames[vm.activeTab][
                                  vm.radioTabs[vm.activeTab]
                                ]
                              }`]: {
                                "Просмотр видео на 80%": {
                                  Params: {
                                    ...vm.$root.ymFields,
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                    });
                    stamps[80] = true;
                  }
                }
              };
              v.onended = function () {
                if (typeof ym !== "undefined") {
                  ym(91468266, "reachGoal", "clinical case", {
                    "Клинический случай": {
                      Видео: {
                        "Экран 3": {
                          [`${vm.tabsNames[vm.activeTab]}`]: {
                            [`${
                              vm.radiosNames[vm.activeTab][
                                vm.radioTabs[vm.activeTab]
                              ]
                            }`]: {
                              "Просмотр видео до конца": {
                                Params: {
                                  ...vm.$root.ymFields,
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                  });
                }
              };
            });
            if (vm.radiosNames[vm.activeTab]) {
              if (typeof ym !== "undefined") {
                ym(91468266, "reachGoal", "clinical case", {
                  "Клинический случай": {
                    "Экран 3 - Сбор жалоб": {
                      "Выбор вопросов пациенту": {
                        [`${vm.tabsNames[vm.activeTab]}`]: {
                          [`${
                            vm.radiosNames[vm.activeTab][
                              vm.radioTabs[vm.activeTab]
                            ]
                          }`]: {
                            Params: {
                              ...vm.$root.ymFields,
                            },
                          },
                        },
                      },
                    },
                  },
                });
              }
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
    activeBody() {
      const vm = this;
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "clinical case", {
          "Клинический случай": {
            "Экран 3 - Сбор жалоб": {
              "Выбор вопросов пациенту": {
                [`${vm.tabsNames[vm.activeTab]}`]: {
                  [`${vm.activeBodyNames[vm.activeBody]}`]: {
                    Params: {
                      ...vm.$root.ymFields,
                    },
                  },
                },
              },
            },
          },
        });
      }
    },
    visible() {
      if (this.visible) {
        const vm = this;
        if (typeof ym !== "undefined") {
          ym(91468266, "reachGoal", "clinical case", {
            "Клинический случай": {
              "Экран 3 - Сбор жалоб": {
                "Показ вкладок": {
                  [`${vm.tabsNames[vm.activeTab]}`]: {
                    Params: {
                      ...vm.$root.ymFields,
                    },
                  },
                },
              },
            },
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/icc_detail.scss";
</style>